import { useSession } from "next-auth/react";
import { NextSeo } from "next-seo";

import dynamic from "next/dynamic";
import Head from "next/head";
import Image from "next/image";
// import Link from "next/link";
import { useRouter } from "next/router";
import Script from "next/script";
import React, { useContext, useEffect, useRef, useState } from "react";
import {  Carousel, Container } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
const RecengineWidget = dynamic(() => import("./RecengineWidget") , {ssr : false , loading: () => <p>Loading Recengine widget</p>});


import { getAuthorizedApi } from "api/apiInstance";
import { useWindowSize } from "api/commonConstants";
import { baseUrlV2 } from "api/constants";
// import getConfig from "next/config";
// import moment from "moment";
// import ReactJWPlayer from "react-jw-player";
// import ClevertapReact from "utils/clevertapHelper";
// import { formatDate, formatDateIST, isoStringWithOffset } from "api/cleverTap";
import {
  formatDate,
  formatDateIST,
  removeEmbeds,
  // isoStringWithOffset,
} from "constants/cardsConstant";
import { getTokenFromCookies } from "constants/loginConstants";
import useIsVisible from "hooks/useInViewport";
import { getLanguage } from "localization/i8intl";
import { getAdsBySize } from "redux/actions/ads.Actions";
import { saveBookmark } from "redux/actions/bookmarksActions";
import { getStats, postLike, storyView } from "redux/actions/postAction";
import { GenerateUniqId } from "utils/deviceIdGenerator";
import { decryptData } from "utils/encryption";
import uiHelper from "utils/uiHelper";
// import { baseUrl } from "api/constants";
import FontSize from "./FontSize";
import ElectionsWidget from "components/elections-2023/ElectionsWidget";
// import Sponsor from "components/Sponsor";
import FAQComponent from "components/faq";
import {
  apstagBidCallback,
  createApsSlotsRosMobile,
  createApsSlotsRosDesktop,
  requestBiddingFromPWT,
} from "./../Ads/index";
import { MasterConfigContext } from "constants/MasterConfigContext";
// import SharePopup from "components/shared/modal/SharePopup";
const SharePopup = dynamic(() => import("components/shared/modal/SharePopup") , {ssr : false , loading: () => <p>Loading Cricket widget</p>});
const WidgetHome = dynamic(() => import("components/cricket/WidgetHome") , {ssr : false , loading: () => <p>Loading Cricket widget</p>});
const CommentSection = dynamic(() => import("./comments") , {ssr : false , loading: () => <p>Comment Section</p>});
// const RelatedNews = dynamic(() => import("./relatedNews"));
const ArticleHTML = dynamic(() => import("./articleHtml") , {ssr : false , loading: () => <p>Article HTML</p>});
const DynamicBanner = dynamic(() =>
  import("components/homePage/dynamicBanner/bannerCarousel"), {ssr : false , loading: () => <p>Dynamic banner</p>}
);


// const DropdownDiv = styled.div`
//   position: absolute;
//   right: 5px;
//   cursor: pointer;
// `;
const VideoPlayer = dynamic(() =>
  import("../../components/shared/videoPlayer") , {ssr : false , loading: () => <p>Comment Section</p>}
);
const TrendingToday = dynamic(
  () => import("../../components/common/trendingToday")
  , {ssr : false , loading: () => <p>Comment Section</p>}

);
const CommentPopup = dynamic(() =>
  import("../../components/shared/modal/commentPopup"), {ssr : false , loading: () => <p>Comment Section</p>}

);
const CustomPopup = dynamic(() =>
  import("../../components/shared/modal/customPopup"), {ssr : false , loading: () => <p>Comment Section</p>}
);
// const CricketSlider = dynamic(
//   () => import("../../components/homePage/cricketSlider"),
//   { ssr: true }
// );
const ReactJWPlayer = dynamic(() => import("react-jw-player"), {ssr : false , loading: () => <p>Comment Section</p>});

const NewsDetailUpdated = ({
  postData,
  postType = "",
  prevUrl = "",
  trendingData = "",
  // cricketResponse = [],
  articlePageBanners = [],
  // electionTopicData = [],
  homePageVideos = [],
  pointsData,
  scoreData,
  cricketTopicData,
  categoryName
}) => {
  // console.log("articlePageBanners", postData);
  var shortsCards;
  const router = useRouter();
  // const [publicRuntimeConfig, setPublicRunTimeConfig] = useState({
  //   electionExitPollToggle: false,
  //   electionResultToggle: true,
  //   vidhansabhaResultToggle: true,
  //   resultVersion: 1.6,
  //   exitPollVersion: 1.2,
  //   electionYear: 2024,
  //   isElectionAlpha: true,
  //   keyCandidate: true,
  // });

  // useEffect(() => {
  //   if (typeof window !== "undefined") {
  //     const remoteConfig = getRemoteConfig(app);
  //     remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

  //     fetchAndActivate(remoteConfig)
  //       .then(() => {
  //         // const titleData = getString(remoteConfig, "electionKeys");
  //         // const parsedData = JSON.parse(titleData);
  //         // setPublicRunTimeConfig(parsedData);
  //         // setVideoUrl(titleData);
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //       });
  //   }
  // }, []);
  const dispatch = useDispatch();
  const { query } = router;
  // const { asPath } = router;
  const ref = useRef();
  const jwRef = useRef();
  const isJWVisible = useIsVisible(jwRef);
  const size = useWindowSize();

  const { data: session } = useSession();
  const [loginPrompt, setLoginPrompt] = useState(false);
  // const [videoUrl, setVideoUrl] = useState("");
  // const [showModal, setShowModal] = useState(false);
  const [postStateData, setPostStateData] = useState([]);
  // const [liked, setLiked] = useState(false);
  const [language, setLanguage] = useState("");
  // const [countLike, setCountLike] = useState(postData?.likeCount);
  const [fontSize, setFontSize] = useState("large");
  const [openShareModal, setOpenShareModal] = useState(false);
  // const [shareData, setShareData] = useState({});
  const [loginShow, setLoginShow] = useState(false);
  // const [isElection, setIsElection] = useState(false);
  const [loadPlayer, setLoadPlayer] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [scrollDirection, setScrollDirection] = useState(null);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [pageScrolled, setPageScrolled] = useState(false);
  const [test , setTest] = useState("test")
  const [arraysData, setArraysData] = useState([postData]);
  const [callRosBottom , setCallRosBottom] = useState(false)
  
  const [indexonScreen, setIndexOnScreen] = useState(0);
  const [currentPlayer, setCurrentPlayer] = useState("jw-player-1");
  const [displayMore, setDisplayMore] = useState(false);
  const [showMore, setShowMore] = useState([true, false, false, false, false]);
  const [hideAppButton, setHideAppButton] = useState(false);
  const [infiniteLikeState, setInfiniteLikeState] = useState([
    postData?.isLiked,
  ]);
  const [infiniteBookmarkState, setInfiniteBookmarkState] = useState([
    postData?.isBookmarked,
  ]);
  const [relatedArticles, setRelatedArticles] = useState([]);
  const [restRelatedArticles, setRestRelatedArticles] = useState([]);

  const [articleChanges, setArticleChanges] = useState(false);
  const [adCalled, setAdCalled] = useState(false);

  const { userLocalDetail } = useSelector(({ AuthReducer }) => AuthReducer);
  const { postDetails } = useSelector(({ PostReducer }) => PostReducer);
  const [bookmarkArticleArray, setBookmkarkArticleArray] = useState([]);
  // const { trendingPosts } = useSelector(({ PostReducer }) => PostReducer);
  const { mobilePopUp } = useSelector(({ AuthReducer }) => AuthReducer);

  const { statistics } = useSelector(({ PostReducer }) => PostReducer);
  var testArray = [];
  var contentContainer;
  // console.log("arraysData postdata", arraysData);

  const [bookmarkArray, setBookmarkArray] = useState([postData?._id]);
  const [showStickyBanner, setShowStickyBanner] = useState(true);

  const authorName = postData?.createdByEmail?.split("@")[0];
  const mainUrl = "all";

  console.log("Article data for ", arraysData[0]);

  const masterConfigCT = useContext(MasterConfigContext);

  //Chunav Yatra

  // const [electionTopicData, setElectionTopicData] = useState([]);

  // const getElectionTopic = async () => {
  //   const res = await fetch(
  //     `${baseUrl}/topicItem/getContentsBySlugAndType?limit=6&skip=1&slug=chunav-yatra-2024&type=video`,
  //     {
  //       method: "GET",
  //       headers: {
  //         "content-type": "application/json",
  //       },
  //     }
  //   );
  //   const newPosts = await res.json();

  //   if (newPosts?.result?.entities?.length > 0) {
  //     console.log("Topic data for elction ", newPosts?.result?.entities);
  //     setElectionTopicData(newPosts?.result?.entities);
  //   } else {
  //     // setHasMore({ ...hasMore, [activeTab]: false });
  //   }
  //   // setSkipPerPage({ ...skipPerPage, [activeTab]: skipPerPage["text"] + 10 });
  //   // } else setLoginPrompt(true);
  // };

  // useEffect(() => {
  //   getElectionTopic();
  // }, []);
  // console.log("Election data", electionTopicData);

  // if (typeof window !== "undefined") {
  //   window.addEventListener("popstate", function (event) {
  //     location.replace("/");
  //     // router.push("/");
  //   });
  // }
  const handleCustomBack = () => {
    if ((prevUrl && articleChanges) || !prevUrl.includes("post")) {
      router.push(prevUrl);
    } else {
      location.replace("/");
    }
  };
  useEffect(() => {
    // window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", handleCustomBack);
    return () => {
      window.removeEventListener("popstate", handleCustomBack);
    };
  }, []);

  useEffect(() => {
    let jw_script = document.getElementById("__jw-ld-json");
    if (jw_script) {
      jw_script.parentNode.removeChild(jw_script);
    }
  });

  useEffect(() => {
    shortsCards = document?.querySelectorAll(".infinite");
    contentContainer =
      document?.getElementsByClassName(".content-container")[0];

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // console.log("entries", entry);
          if (entry.isIntersecting) {
            setArticleChanges(true);
            var index = parseInt(entry.target.className.split(" ")[2]);
            setIndexOnScreen(index);

            testArray.push(index);
            // console.log("index on screen  is", index, entry.target.className);

            if ((index === 0 && testArray.length > 1) || index !== 0) {
              setTimeout(function () {
                if (typeof googletag.pubads === "function") {
                  // console.log("Refresh fired");
                  googletag.pubads().refresh();
                }
              }, 500);
            }
          } else {
            var index = parseInt(entry.target.className.split(" ")[2]);
            console.log("In observer going out of screen index", index);
          }
        });
      },
      { threshold: 0.3, root: contentContainer }
    );
    shortsCards?.length > 0 &&
      shortsCards?.forEach((entry) => {
        // console.log("In observer each", entry);

        observer.observe(entry);
      });
  }, [arraysData]);

  useEffect(() => {
    // Function to handle the intersection event of the first article
    const onIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // console.log("Comments section is in view!");
          // Optionally, you can stop observing once it's visible
          // observer.unobserve(entry.target);
          setIndexOnScreen(0);
        } else {
          // console.log("Comments section is not in view!");
        }
      });
    };
    const observer = new IntersectionObserver(onIntersection, {
      root: null, // Observe in the viewport
      rootMargin: "0px", // No margin
      threshold: 0.5, // 50% of the element must be visible
    });

    // Get the comments section element
    const commentsSection = document.querySelector(".first-article-observer");

    // Start observing the comments section
    observer.observe(commentsSection);
  }, [arraysData]);
  useEffect(() => {
    if (articleChanges) {
      changeUrl();
    }
  }, [indexonScreen]);

  useEffect(() => {
    const { jwplayer } = window;
    if (jwplayer) {
      // console.log("Player exists in dom");
      delete window.jwplayer;
      var script = document.createElement("script");
      script.src = "https://cdn.jwplayer.com/libraries/gtSITKWv.js";
      script.defer = true

      // Execute callback once the script has finished loading
      script.onload = () => {
        // console.log("Script loaded");
        setLoadPlayer(true);
      };

      // Append the script tag to the document's head
      // document.head.appendChild(script);
      document.body.appendChild(script);

    } else {
      setLoadPlayer(true);
      // console.log("Player does not exists in dom");
    }
  }, []);

  useEffect(() => {
    console.log("isFirstTime", isFirstTime);
  }, [isFirstTime]);

  useEffect(() => {
    let lastScrollY = window.pageYOffset;
    let animationFrameId;
    let scrollingTimeout;
    const updateScrollDirection = () => {
      setHideAppButton(true);
      setIsFirstTime(false);
      setPageScrolled(true);
      clearTimeout(scrollingTimeout);
      setCallRosBottom(true)
      cancelAnimationFrame(animationFrameId);
      animationFrameId = requestAnimationFrame(() => {
        scrollingTimeout = setTimeout(() => {
          setHideAppButton(false);
        }, 700);
      });

      const scrollY = window.screenY;
      const direction = scrollY > lastScrollY ? "down" : "up";
      if (
        direction !== scrollDirection &&
        (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)
      ) {
        setScrollDirection(direction);
        if (isFirstTime) {
          setIsFirstTime(false);
        }
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };
    window.addEventListener("scroll", updateScrollDirection); // add event listener
    return () => {
      window.removeEventListener("scroll", updateScrollDirection);
    };
  }, [scrollDirection, isFirstTime]);
  // useEffect(() => {
  //   dispatch(getTrendingPosts());
  // }, [dispatch]);

  useEffect(() => {
    runChartBeatScript();
  }, [indexonScreen]);
  useEffect(() => {
    if (!isFirstTime) {
      runScripts();
      fetchRelatedArticles(postData._id);
    }
  }, [isFirstTime]);

  useEffect(() => {
    setTimeout(() => {
      if (typeof window.gtag !== "undefined") {
        gtag("create", "G-RXRPKR4310", "auto");
        gtag("create", "G-6DCEWMBVGD", "auto");
        // ga("set", "dimension1", "thelallantop.com");
        // ga("set", "dimension2", `${postData?.categorySlug}`);
        // let date = new Date().toISOString().slice(0, 10);
        // ga("set", "dimension3", `${date}`);
        // ga("send", "pageView", {
        //   eventCategory: `${postData?.type === "text" ? "articles" : "videos"}`,
        //   eventLabel: `page_view_${postData.englishTitle}`,
        //   eventValue: `${postData.permalink}`,
        // });
        if (postData?.type === "text") {
          let page_article_data_video = {};
          page_article_data_video["send_to"] = `G-RXRPKR4310`;
          page_article_data_video["eventCategory"] = `Article Pages`;
          page_article_data_video[
            "eventLabel"
          ] = `page_view_${postData.englishTitle}`;
          page_article_data_video["eventValue"] = `${postData.permalink}`;
          gtag("event", "article_page_view", page_article_data_video);
        } else {
          let page_article_data = {};
          page_article_data["send_to"] = `G-RXRPKR4310`;
          page_article_data["eventCategory"] = `Video Pages`;
          page_article_data[
            "eventLabel"
          ] = `page_view_${postData.englishTitle}`;
          page_article_data["eventValue"] = `${postData.permalink}`;
          gtag("event", "video_page_view", page_article_data);

          let page_article_data2 = {};
          page_article_data2["send_to"] = `G-6DCEWMBVGD`;
          page_article_data2["eventCategory"] = `Video Pages`;
          page_article_data2[
            "eventLabel"
          ] = `page_view_${postData.englishTitle}`;
          page_article_data2["eventValue"] = `${postData.permalink}`;
          gtag("event", "video_page_view", page_article_data2);
        }
      }
    }, 1500);
  }, [isFirstTime]);
  useEffect(() => {
    if (relatedArticles?.length > 0) {
      fetchArticleData();
    }
  }, [relatedArticles]);

  useEffect(() => {
    setPostStateData(postData);
    // if (postData) {
    //   // setLiked(postData?.isLiked);
    // }
  }, [postData]);

  useEffect(() => {
    if (
      postData?.postId
        ? postDetails?._id === postData?.postId
        : postDetails?._id === postData?._id
    ) {
      setPostStateData(postDetails);
      // setLiked(postDetails?.isLiked);
      // setCountLike(postDetails?.likeCount);
    }
  }, [postDetails, postData?._id, postData?.postId]);



  useEffect(() => {
    if (!postData || !postData?.additionalSchemas?.length > 0) return;

    const additionalSchema = postData?.additionalSchemas[0]
  
    const script = document.createElement("script");
    script.type = "application/ld+json";
  
    const jsonLdData = {
      "@context": additionalSchema?.context,
      "@type": additionalSchema?.type,
      "actor" : additionalSchema?.actors,
      "dateCreated" : additionalSchema?.dateCreated,
      "description" : additionalSchema?.description,
      "director" : additionalSchema?.director,
      "image" : additionalSchema?.image,
      "name" :  additionalSchema?.name,
      "review" : additionalSchema?.review,
      "sameAs" : additionalSchema?.sameAs,
      "url" : additionalSchema?.url
    };
  
    script.text = JSON.stringify(additionalSchema);
  
    // Optional: remove old script if exists
    const existing = document.getElementById("my-script-movie");
    if (existing) {
      existing.remove();
    }
  
    script.id = "my-script-movie";
    document.head.appendChild(script);
  }, [postData]);

  // useEffect(()=>{
  //   window._comscore = window._comscore || [];
  //     // Push Comscore configuration
  //     window._comscore.push({
  //       c1: "2",
  //       c2: "8549097",
  //       options: {
  //         enableFirstPartyCookie: true
  //       }
  //     });
  //     // Create <script> element
  //     const script = document.createElement('script');
  //     script.async = true;
  //     script.src = "https://sb.scorecardresearch.com/cs/8549097/beacon.js";
  //     // Find the first script element on the page
  //     const firstScript = document.getElementsByTagName('script')[0];
  //     // Insert the new script before the first script element
  //     firstScript.parentNode.insertBefore(script, firstScript);
  // },[]);
  useEffect(() => {
    GenerateUniqId().then((deviceId) => {
      let viewObj = {
        postId: postData._id,
        deviceType: "web",
        deviceId,
      };
      dispatch(storyView(viewObj, postType));
    });
  }, [postData?._id, postType, dispatch]);

  useEffect(() => {
    setLanguage(getLanguage());
  }, []);

  useEffect(() => {
    dispatch(getAdsBySize());
  }, [dispatch]);
  // useEffect(() => {
  //   if (router.asPath.includes("/sports")) {

  //     const script = document.createElement("script");
  //     script.innerHTML = `
  //     window._izq = window._izq || [];
  //     window._izq.push(["userProfile", {
  //       "add": {
  //         "Category": "Sports"
  //       }
  //     }]);
  //   `;
  //     script.defer = true;

  //     document.head.appendChild(script);
  //   }

  //   return () => {
  //     document.head.removeChild(script); // Cleanup when component unmounts
  //   };
  // }, []);
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (
  //       size.width < 600 &&
  //       router?.pathname.includes("/post/") &&
  //       mobilePopUp < 1
  //     ) {
  //       setShowAppRedirection(true);
  //       dispatch(handleMobilePopUpSuccess());
  //     }
  //   }, 5000);
  //   return () => clearTimeout(timer);
  // }, [size]);

  function handleCommentClick() {
    const showMoreButton = document.querySelector(".tbl-read-more-btn ");
    if (showMoreButton) {
      showMoreButton.click();
    }
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }

  // useEffect(() => {
  //   if (postData?.assetFileLink?.includes("video.m3u8")) {
  //     let file = postData?.assetFileLink?.replace("video.m3u8", "video.mp4");
  //     // setVideoUrl(file);
  //   } else if (postData?.assetFileLink?.includes("master.m3u8")) {
  //     let file1 = postData?.assetFileLink?.replace("master.m3u8", "video.mp4");
  //     // setVideoUrl(file1);
  //   } else {
  //     let file2 = postData?.assetFileLink;
  //     // setVideoUrl(file2);
  //   }
  // }, [postData]);

  useEffect(() => {
    if (window && typeof window.localStorage !== "undefined") {
      let fs = window.localStorage.getItem("fontSize");
      if (fs && ["small", "normal", "large"].includes(fs)) {
        setFontSize(fs);
      }
    }
  }, [fontSize]);
  // useEffect(() => {
  //   fetch(`${baseUrl}/live/listWithStreamUrl?limit=12&skip=1`)
  //     .then((res) => res.json())
  //     .then((d) => {
  //       setIsElection(d?.result?.entities[0]?.isElection);
  //     });
  // }, []);

  const handleLike = (postObj, postDetails, index) => {
    if (userLocalDetail?.id || session?.user?.email) {
      dispatch(postLike(postObj, postType, postDetails));
      let alteredLikeArr = [...infiniteLikeState];
      alteredLikeArr[index] = !infiniteLikeState[index];
      setInfiniteLikeState(alteredLikeArr);
    } else {
      setLoginShow(true);
    }
  };

  useEffect(() => {
    if (userLocalDetail?.id || session?.user?.email) {
      dispatch(getStats(postData?._id));
    }
  }, []);

  const handleClose = () => {
    setShowButton((e) => !e);
  };

  const handleBookmark = (_id, type, index) => {
    if (userLocalDetail?.id || session?.user?.email) {
      const postObj = {
        table: "post",
        postId: _id,
        type: type,
      };
      dispatch(saveBookmark(postObj));
      let alteredBookArr = [...infiniteBookmarkState];
      alteredBookArr[index] = !infiniteBookmarkState[index];
      setInfiniteBookmarkState(alteredBookArr);
      //setShowDropdown((e) => !e);
      bookmarkArticleArray[index].isBookmarked = bookmarkArticleArray[index]
        ?.isBookmarked
        ? false
        : true;
    } else {
      if (setLoginShow) setLoginShow(true);
    }
  };
  const handleShare = (articleData) => {
    
    const share = {
      title: articleData?.title,
      text: articleData?.title,
    };
    //if (shareUrl) share.url = shareUrl;

    share.url =
      articleData?.permalink +
      `?utm_source=Internal_LT&utm_medium=${postData?.type}&utm_name=system-share`;

    //console.log("share: ", share);
    // setShareData(share);
    if (!navigator || !navigator.share) {
      setOpenShareModal(true);
      
      // console.log("Platform not supported!");
    } else {
      
      uiHelper.share(share);
    }
  };
  const changeUrl = () => {
    if (indexonScreen === 0) {
      var currentURL = window.location.href;
      let count = 0;
      let baseURl = "";
      [...currentURL].forEach((c) => {
        if (c === "/") {
          count++;
        }
        if (count < 3) {
          baseURl += c;
        }
      });
      baseURl =
        baseURl +
        "/" +
        arraysData[0].categorySlug +
        "/post/" +
        arraysData[0].postSlug;

      window.history.pushState({}, document.title, baseURl);
    } else {
      var currentURL = window.location.href;
      let count = 0;
      let baseURl = "";
      [...currentURL].forEach((c) => {
        if (c === "/") {
          count++;
        }
        if (count < 3) {
          baseURl += c;
        }
      });
      baseURl =
        baseURl +
        "/" +
        arraysData[indexonScreen]?.categorySlug +
        "/post/" +
        arraysData[indexonScreen]?.postSlug;

      window.history.pushState({}, document.title, baseURl);
      window._comscore = window._comscore || [];
      // Push Comscore configuration
      window._comscore.push({
        c1: "2",
        c2: "8549097",
        cs_ucfr: "",
        options: {
          enableFirstPartyCookie: true,
          bypassUserConsentRequirementFor1PCookie: true
        },
        // cs_ucfr: 0,
        // options: {
        //   enableFirstPartyCookie: true,
        // },
      });
      // Create <script> element
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://sb.scorecardresearch.com/cs/8549097/beacon.js";
      // Find the first script element on the page
      const firstScript = document.getElementsByTagName("script")[0];
      // Insert the new script before the first script element
      firstScript.parentNode.insertBefore(script, firstScript);

      apstag.fetchBids(
        {
          slots:
            size.width < 768
              ? createApsSlotsRosMobile({})
              : createApsSlotsRosDesktop({}),
          timeout: 2e3,
        },
        apstagBidCallback
      );

      const script2 = document.createElement('script');
      script2.type = 'text/javascript';
      script2.async = true;
      script2.src = "//pb-script-03.ccgateway.net/script?id=cca&parentId=" + window.location.hostname;
      
      // Append the script to the document
      // document.body.appendChild(script);
      document.body.appendChild(script2);

  
  
    }
  };
  const handleVideoPlay = async (currentId) => {
    if (window !== undefined) {
      const { jwplayer } = window;

      if (jwplayer && currentPlayer !== currentId) {
        // jwplayer(currentId).setFloating(true)
        jwplayer(currentPlayer).pause();
        jwplayer(currentPlayer).setFloating(false);
      } else {
        // console.log("jwplayer not found or same player");
      }
    }
  };

  function shareLinkToWhatsApp(articleData) {
    const share = {
      title: arraysData[indexonScreen]?.title,
      text: arraysData[indexonScreen]?.title,
    };
    //if (shareUrl) share.url = shareUrl;
    share.url =
      arraysData[indexonScreen]?.permalink +
      `?utm_source=Internal_LT&utm_medium=${postData?.type}&utm_name=whatsapp-share`;
    const whatsappLink = `whatsapp://send?text=${encodeURIComponent(
      `${share.title} ${share.url}`
    )}`;
    window.location.href = whatsappLink;
  }

  // const countFormat = (count) => {
  //   return count > 1000 ? (count / 1000).toFixed(1).concat("k") : count;
  // };

  const keywords =
    arraysData[indexonScreen] && arraysData[indexonScreen].altTags
      ? arraysData[indexonScreen].altTags.toString()
      : "";

  useEffect(() => {
    // console.log("Calling ads");
    var showAds = true;

    if (process.env.NEXT_PUBLIC_ADS_ONSCROLL === "true" && isFirstTime) {
      showAds = false;
    }
    if (showAds && !adCalled) {
      setAdCalled(true);
      setTimeout(() => {
        // console.log("showAds", showAds, process.env.NEXT_PUBLIC_ADS_ONSCROLL);

        window.googletag = window.googletag || { cmd: [] };
        if (window.screen.width > 600) {
          googletag.cmd.push(function () {
            googletag
              .defineSlot(
                "/1007232/Lallantop_Desktop_ROS_ATF_728x90",
                [
                  [728, 90],
                  [970, 250],
                  [970, 90],
                ],
                "div-gpt-ad-1701945163318-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/Lallantop_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1701945220410-0"
              )
              .addService(googletag.pubads());
            // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Desktop_ROS_MTF_1_728x90",
            //     [728, 90],
            //     "div-gpt-ad-1701945220410-1"
            //   )
            //   .addService(googletag.pubads());
            // if (removeEmbeds(postData?.articleHTML).split("</p>").length >= 4) {
            //   googletag
            //     .defineSlot(
            //       "/1007232/Lallantop_Desktop_ROS_MTF_2_728x90",
            //       [728, 90],
            //       "div-gpt-ad-1701945220410-2"
            //     )
            //     .addService(googletag.pubads());
            // }
            if (postData?.type === "text") {
              googletag
                .defineSlot(
                  "/1007232/Lallantop_Desktop_ROS_MTF_3_728x90",
                  [728, 90],
                  "div-gpt-ad-1701945220410-3"
                )
                .addService(googletag.pubads());
            }
            googletag
              .defineSlot(
                "/1007232/Lallantop_Desktop_ROS_BTF_300x250",
                [
                  [300, 250],
                  [300, 600],
                ],
                "div-gpt-ad-1701945864013-0"
              )
              .addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().setTargeting("Category", `${categoryName},story,${postData?._id}`);
            googletag
              .pubads()
              .setTargeting("Keywords", keywords);
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            requestBiddingFromPWT();
          });
        } else {
          googletag.cmd.push(function () {
            googletag
              .defineSlot(
                "/1007232/Lallantop_Mobile_ROS_ATF_300x250",
                [
                  [336, 280],
                  [300, 250],
                ],
                "div-gpt-ad-1701946028239-0"
              )
              .addService(googletag.pubads());
            // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Mobile_ROS_MTF_1_300x250",
            //     [
            //       [336, 280],
            //       [300, 250],
            //     ],
            //     "div-gpt-ad-1701946028239-1"
            //   )
            //   .addService(googletag.pubads());
            // if (removeEmbeds(postData?.articleHTML).split("</p>").length >= 4) {
            //   googletag
            //     .defineSlot(
            //       "/1007232/Lallantop_Mobile_ROS_MTF_2_300x250",
            //       [
            //         [336, 280],
            //         [300, 250],
            //       ],
            //       "div-gpt-ad-1701946028239-2"
            //     )
            //     .addService(googletag.pubads());
            // }
            googletag
              .defineSlot(
                "/1007232/Lallantop_Mobile_ROS_BTF_300x250",
                [
                  [336, 280],
                  [300, 250],
                ],
                "div-gpt-ad-1701946028239-3"
              )
              .addService(googletag.pubads());
            // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Mobile_ROS_Bottom_320x50",
            //     [320, 50],
            //     "div-gpt-ad-1701946324333-0"
            //   )
            //   .addService(googletag.pubads());
            googletag
              .defineOutOfPageSlot(
                "/1007232/Lallantop_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              )
              .addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().setTargeting("Category", `${categoryName},story,${postData?._id}`);
            googletag
              .pubads()
              .setTargeting("Keywords", keywords);
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            requestBiddingFromPWT();
          });
        }

        // apstag.fetchBids(
        //   {
        //     slots:
        //       size?.width < 499
        //         ? createApsSlotsRosMobile({})
        //         : createApsSlotsRosDesktop({}),
        //     timeout: 2e3,
        //   },
        //   apstagBidCallback
        // );
      }, 500);
    }
  }, [postData, isFirstTime]);


  useEffect(()=> {

    if(pageScrolled){
      window.googletag = window.googletag || { cmd: [] };
    if(window.screen.width > 600){
      googletag.cmd.push(function () {
        googletag
              .defineSlot(
                "/1007232/Lallantop_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1701945220410-1"
              )
              .addService(googletag.pubads());
            if (removeEmbeds(postData?.articleHTML).split("</p>").length >= 4) {
              googletag
                .defineSlot(
                  "/1007232/Lallantop_Desktop_ROS_MTF_2_728x90",
                  [728, 90],
                  "div-gpt-ad-1701945220410-2"
                )
                .addService(googletag.pubads());
            }
        googletag.pubads().enableSingleRequest();
        googletag.pubads().setTargeting("Category", `${categoryName},story,${postData?._id}`);
          googletag
            .pubads()
            .setTargeting("Keywords", keywords);
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
      })
    }else{
      googletag.cmd.push(function () {
        googletag
              .defineSlot(
                "/1007232/Lallantop_Mobile_ROS_MTF_1_300x250",
                [
                  [336, 280],
                  [300, 250],
                ],
                "div-gpt-ad-1701946028239-1"
              )
              .addService(googletag.pubads());
            if (removeEmbeds(postData?.articleHTML).split("</p>").length >= 4) {
              googletag
                .defineSlot(
                  "/1007232/Lallantop_Mobile_ROS_MTF_2_300x250",
                  [
                    [336, 280],
                    [300, 250],
                  ],
                  "div-gpt-ad-1701946028239-2"
                )
                .addService(googletag.pubads());
            }
        googletag.pubads().enableSingleRequest();
        googletag.pubads().setTargeting("Category", `${categoryName},story,${postData?._id}`);
          googletag
            .pubads()
            .setTargeting("Keywords", keywords);
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
      })
    }
    }
    
  },[pageScrolled])


  useEffect(() => {
    if(callRosBottom){
      window.googletag = window.googletag || { cmd: [] };
      if (window.screen.width <= 600) {
        googletag.cmd.push(function () {
          googletag
          .defineSlot(
            "/1007232/Lallantop_Mobile_ROS_Bottom_320x50",
            [320, 50],
            "div-gpt-ad-1701946324333-0"
          )
          .addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", `${categoryName},story,${postData?._id}`);
            googletag
              .pubads()
              .setTargeting("Keywords", keywords);
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            requestBiddingFromPWT();
        })
      }
    }
  },[callRosBottom])

  useEffect(() => {

    if(size.width){
      
      apstag.fetchBids(
        {
          slots:
            size.width < 768
              ? createApsSlotsRosMobile({})
              : createApsSlotsRosDesktop({}),
          timeout: 2e3,
        },
        apstagBidCallback
      );
    }
   
  },[size.width])

  const runChartBeatScript = () => {
    (function () {
      /* CONFIGURATION START */
      var _sf_async_config = (window._sf_async_config =
        window._sf_async_config || {});
      _sf_async_config.uid = 60355;
      _sf_async_config.domain = "thelallantop.com";
      _sf_async_config.useCanonical = true;
      _sf_async_config.useCanonicalDomain = true;
      _sf_async_config.sections = `${arraysData[indexonScreen]?.categorySlug}`;
      _sf_async_config.authors = `${arraysData[indexonScreen]?.contentAuthors[0]?.fullname}`;
      _sf_async_config.path = `/${arraysData[indexonScreen]?.categorySlug}/post/${arraysData[indexonScreen].postSlug}`;
      /* CONFIGURATION END */
      function loadChartbeat() {
        var e = document.createElement("script");
        var n = document.getElementsByTagName("script")[0];
        e.type = "text/javascript";
        e.async = true;
        e.defer = true
        if (postData?.type === "video") {
          e.src = "//static.chartbeat.com/js/chartbeat_video.js";
        } else {
          e.src = "//static.chartbeat.com/js/chartbeat.js";
        }
        n.parentNode.insertBefore(e, n);
      }
      setTimeout(() => {
        loadChartbeat();
      }, 500);
      loadChartbeat();

      const twitter = document.createElement("script");
      twitter.setAttribute("src", "https://platform.twitter.com/widgets.js");
      twitter.setAttribute("async", "true");
      twitter.setAttribute("defer", "true");

      // document.head.appendChild(twitter);
      document.body.appendChild(twitter);


      const facebook = document.createElement("script");
      twitter.setAttribute(
        "src",
        "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2"
      );
      twitter.setAttribute("async", "true");
      twitter.setAttribute("defer", "true");

      // document.head.appendChild(facebook);
      document.body.appendChild(facebook);


      const reddit = document.createElement("script");
      reddit.setAttribute("src", "https://embed.reddit.com/widgets.js");
      reddit.setAttribute("async", "true");
      reddit.setAttribute("defer", "true");
      // document.head.appendChild(reddit);
      document.body.appendChild(reddit);

    })();
  };

  const runScripts = () => {
    //console.log("Scripts Called");
    if (postData?.type !== "video") {
      (function (v, d, o, ai) {
        ai = d.createElement("script");
        ai.defer = true;
        ai.async = true;
        ai.src = v.location.protocol + o;
        d.head.appendChild(ai);
      })(window, document, "//a.vdo.ai/core/v-thelallantop/vdo.ai.js");
      window, document, "//a.vdo.ai/core/v-thelallantop-v1/vdo.ai.js";
    } else {
      (function (v, d, o, ai) {
        ai = d.createElement("script");
        ai.defer = true;
        ai.async = true;
        ai.src = v.location.protocol + o;
        d.head.appendChild(ai);
      })(window, document, "//a.vdo.ai/core/v-thelallantop-v1/vdo.ai.js");
    }

    window._taboola = window._taboola || [];
    _taboola.push({ article: "auto" });
    !(function (e, f, u, i) {
      if (!document.getElementById(i)) {
        e.async = 1;
        e.src = u;
        e.id = i;
        f.parentNode.insertBefore(e, f);
      }
    })(
      document.createElement("script"),
      document.getElementsByTagName("script")[0],
      "//cdn.taboola.com/libtrc/indiatoday-thelallantop/loader.js",
      "tb_loader_script"
    );
    if (window.performance && typeof window.performance.mark == "function") {
      window.performance.mark("tbl_ic");
    }
    window._taboola = window._taboola || [];
    _taboola.push({
      mode: "alternating-thumbnails-a",
      container: "taboola-below-article-thumbnails",
      placement: "Below Article Thumbnails",
      target_type: "mix",
    });
    // (function () {
    //   /* CONFIGURATION START */
    //   var _sf_async_config = (window._sf_async_config =
    //     window._sf_async_config || {});
    //   _sf_async_config.uid = 60355;
    //   _sf_async_config.domain = "thelallantop.com";
    //   _sf_async_config.useCanonical = true;
    //   _sf_async_config.useCanonicalDomain = true;
    //   _sf_async_config.sections = `${postData?.categorySlug}`;
    //   _sf_async_config.authors = `${postData?.contentAuthors[0]?.fullname}`;
    //   /* CONFIGURATION END */
    //   function loadChartbeat() {
    //     var e = document.createElement("script");
    //     var n = document.getElementsByTagName("script")[0];
    //     e.type = "text/javascript";
    //     e.async = true;
    //     if (postData?.type === "video") {
    //       e.src = "//static.chartbeat.com/js/chartbeat_video.js";
    //     } else {
    //       e.src = "//static.chartbeat.com/js/chartbeat.js";
    //     }
    //     n.parentNode.insertBefore(e, n);
    //   }
    //   loadChartbeat();

    //   const twitter = document.createElement("script");
    //   twitter.setAttribute("src", "https://platform.twitter.com/widgets.js");
    //   twitter.setAttribute("async", "true");
    //   document.head.appendChild(twitter);

    //   const reddit = document.createElement("script");
    //   reddit.setAttribute("src", "https://embed.reddit.com/widgets.js");
    //   reddit.setAttribute("async", "true");
    //   document.head.appendChild(reddit);
    // })();
  };
  useEffect(() => {
    if (relatedArticles.length > 1) {
      let ar = [];
      relatedArticles.forEach((article) => {
        ar.push(article?._id);
      });
      setBookmarkArray([...bookmarkArray, ...ar]);
    }
  }, [relatedArticles]);

  const fetchRelatedArticles = async (id) => {
    const data = await fetch(
      `${baseUrlV2}/web/related-article?_id=${id}&type=text`,
      {
        headers: {
          accesstype: "web",
        },
      }
    );
    const amp = await data.json();
    const dat = amp?.result;
    setRelatedArticles(dat);
  };

  useEffect(() => {
    if (
      bookmarkArray.length > 1 &&
      (userLocalDetail?.id || session?.user?.email)
    ) {
      let articlesBookmark = [{}, {}, {}, {}, {}];
      bookmarkArray.forEach(async (item, index) => {
        const token = getTokenFromCookies(document.cookie);
        const axios = await getAuthorizedApi(token);
        const res = await axios.post(
          `${process.env.NEXT_PUBLIC_APP_API_URL}/v2/web/getStatistics`,
          {
            _id: item,
          }
        );
        articlesBookmark[index] = res.data.result;
        setBookmkarkArticleArray(articlesBookmark);
      });
    }
  }, [bookmarkArray]);
  const fetchArticleData = async () => {
    // fetchRelatedArticles(postData._id);
    let ar = [];
    const token = getTokenFromCookies(document.cookie);
    const accessToken = await decryptData(token);
    var headers;
    if (accessToken) {
      headers = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
    } else {
      headers = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
    }

    for (let x = 0; x < 4; x++) {
      const data = await fetch(
        `${baseUrlV2}/web/postDetailsByCategory/${relatedArticles[x].categorySlug}/${relatedArticles[x].postSlug}?accessType=web`,
        headers
      );
      const amp = await data.json();
      const dat = amp?.result;
      ar.push(dat);
    }

    if (arraysData?.length > 0) {
      
      setArraysData([...arraysData, ...ar]);
    }
    let likeArray = [...infiniteLikeState];
    let bookmarkArray = [...infiniteBookmarkState];
    ar?.forEach((article, articleIndex) => {
      likeArray.push(article?.isLiked);
      bookmarkArray.push(article?.isBookmarked);
    });
    setInfiniteBookmarkState(bookmarkArray);
    setInfiniteLikeState(likeArray);
  };
  useEffect(() => {
    // console.log("arraysData", arraysData);
  }, [arraysData]);

  const handleReadMore = (showIndex) => {
    let newShowArr = [...showMore];
    newShowArr[showIndex] = true;
    setShowMore(newShowArr);
  };

  // const convertToIST = (inputTime) => {
  //   const utcDate = new Date(inputTime);

  //   // Remove milliseconds
  //   utcDate.setMilliseconds(0);

  //   // Add 5 hours and 30 minutes to convert to IST
  //   const istDate = new Date(utcDate.getTime());

  //   // Format IST date components
  //   const year = istDate.getUTCFullYear();
  //   const month = String(istDate.getUTCMonth() + 1).padStart(2, "0");
  //   const day = String(istDate.getUTCDate()).padStart(2, "0");
  //   const hours = String(istDate.getUTCHours()).padStart(2, "0");
  //   const minutes = String(istDate.getUTCMinutes()).padStart(2, "0");
  //   const seconds = String(istDate.getUTCSeconds()).padStart(2, "0");

  //   // Construct the IST time string
  //   // var istTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+05:30`;
  //   var istTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

  //   var originalTime = new Date(istTime);

  //   // Add 5 hours and 30 minutes
  //   originalTime.setHours(originalTime.getHours() + 5);
  //   originalTime.setMinutes(originalTime.getMinutes() + 30);

  //   // Format the result
  //   var formattedTime =
  //     typeof originalTime === Date &&
  //     originalTime?.toISOString()?.slice(0, 19)?.replace("T", "T");
  //   formattedTime = formattedTime + "+05:30";

  //   return formattedTime;
  // };
  const convertToIST = (dateTimeString = "") => {
    try {
      // Split the datetime string into date and time parts
      const [datePart, timePart] = dateTimeString?.split(" ");

      // Concatenate the date and time parts with 'T' in between
      const isoDateTime = `${datePart}T${timePart}`;

      // Append the timezone offset
      const isoDateTimeWithOffset = isoDateTime + "+05:30";

      return isoDateTimeWithOffset;
    } catch (error) {
      console.error(error);
      return dateTimeString;
    }
  };

  const handleScroll = () => {
    const isScrolling = document.body.scrollHeight > window.innerHeight;
    setIsNotScrolling(!isScrolling);
  };
  // console.log("PostData ", postData);
  console.log("array of showMore ", showMore);
  const aspectRatio =
    size.width > size.height
      ? size.width / size.height
      : size.height / size.width;
  console.log("aspect ratio is ", aspectRatio);
  return (
    <div style={{ minHeight: "90vh" }}>
      <Head>
        <link
          rel="amphtml"
          href={`${process.env.NEXT_PUBLIC_BASE_URL}/amp/${arraysData[indexonScreen]?.categorySlug}/post/${arraysData[indexonScreen]?.postSlug}`}
        />
        <meta property="fb:pages" content="1453842511589254"></meta>
        {/* <meta property="article:published_time" content={postData?.publishedAtIST}></meta>
        <meta property="article:modified_time" content={postData?.updatedAtIST}></meta> */}

        <meta
          property="article:published_time"
          // content={convertToIST(arraysData[indexonScreen]?.publishedAt)}
          content={arraysData[indexonScreen]?.publishedAtIST}
        ></meta>
        <meta
          property="article:modified_time"
          content={arraysData[indexonScreen]?.updatedAtIST}
        ></meta>
        <meta
          name="twitter:title"
          content={arraysData[indexonScreen]?.title}
        ></meta>
        <meta
          name="twitter:image"
          content={arraysData[indexonScreen]?.headingImageUrl}
        ></meta>
        <meta name="twitter:site_name" content="The Lallantop"></meta>
        <meta
          name="twitter:description"
          content={arraysData[indexonScreen]?.shortText}
        ></meta>
        <meta
          name="twitter:url"
          content={
            arraysData[indexonScreen]?.permalink ||
            arraysData[indexonScreen]?.seoData?.canonicalURL
          }
        ></meta>
        {keywords && <meta name="keywords" content={`${keywords}`} />}
        <link
          rel="preconnect"
          crossOrigin="true"
          href="https://static.chartbeat.com"
        ></link>
      </Head>

      <NextSeo
        title={
          arraysData[indexonScreen]?.seoData?.metaTitle
          // "" +
          // (arraysData[indexonScreen]?.type === "text" ? " Article" : " Video")
          // arraysData[indexonScreen]?.seoData?.metaTitle + " - The Lallantop"
        }
        description={arraysData[indexonScreen]?.seoData?.metaDescription}
        canonical={
          arraysData[indexonScreen]?.permalink ||
          arraysData[indexonScreen]?.seoData?.canonicalURL
        }
        datePublished={arraysData[indexonScreen]?.publishedAtIST}
        dateModified={arraysData[indexonScreen]?.updatedAtIST}
        openGraph={{
          url:
            arraysData[indexonScreen]?.permalink ||
            arraysData[indexonScreen]?.seoData?.canonicalURL,
          title: arraysData[indexonScreen]?.title,
          description: arraysData[indexonScreen]?.shortText,
          type: "website",
          images: [
            {
              url: arraysData[indexonScreen]?.headingImageUrl,
              alt: arraysData[indexonScreen]?.imgCaption,
            },
          ],
          site_name: "The Lallantop",
        }}
        twitter={{
          handle: "@TheLallantop",
          site: "@TheLallantop",
          cardType: "summary_large_image",
        }}
        facebook={{
          appId: "574628820637757",
        }}
        robotsProps={{
          // maxSnippet: -1,
          maxImagePreview: "large",
          
         
          
          // maxVideoPreview: -1,
        }}
        // additionalMetaTags={[{
        //   name: 'googlebot',
        //   content:'max-image-preview: standard'
        // },{
        //   name: 'robots',
        //   content:'max-image-preview: large'
        // }]}
       

      />
      {pageScrolled &&  <RecengineWidget size={size} postId={postData?._id} />}

      {categoryName == 'sports' && masterConfigCT['ChampionsTrophyWidget']['ShowWidgetOnAllSport'] &&  


<div><WidgetHome newsData = {cricketTopicData}    scoreData = {scoreData} pointsData={pointsData}  table = {pointsData.standings.stage1.groups[0]} size = {size}/></div>

}

      {articlePageBanners?.length > 0 && (
        <div
          className={`checkMobileOrNot ${
            articlePageBanners?.length === 1 ? "stickyArticleBanner" : ""
          } ${
            articlePageBanners?.length === 1 && !showStickyBanner
              ? "remove-sticky"
              : ""
          }`}
          style={{ margin: "5px 6px 0 6px" }}
        >
          <DynamicBanner
            list={articlePageBanners}
            type={"msite"}
            fromArticlePage={true}
            setShowStickyBanner={setShowStickyBanner}
            showStickyBanner={showStickyBanner}
            page={"article"}
          />
        </div>
      )}
      {/* {cricketResponse.length > 0 && (
        <div
          // className="checkMobileOrNot "
          style={
            articlePageBanners?.length > 0
              ? { minHeight: "198px", marginTop: "-6px", marginLeft: "4px" }
              : { minHeight: "198px" }
          }
        >
          <CricketSlider
            cricketResponse={cricketResponse}
            firstScroll={!isFirstTime}
          />
        </div>
      )} */}

      {/* <div className="iframe-container iframe-article-container">
        <div
          className="checkDesktopOrNot election-banner"
          onClick={() =>
            router.push("https://www.thelallantop.com/all/election")
          }
          style={{
            width: "88%",
            minHeight: "66px",
            marginBottom: "-10px",
            paddingTop: "10px",

            cursor: "pointer",
          }}
        >
          <img
            style={{ minWidth: "100%" }}
            src={`https://static.thelallantop.com/images/post/1701653398038_1270x90_copy_(1).webp?${
              isFirstTime ? "width=300" : ""
            }`}
            alt="adda-banner"
          />
        </div>
        <div className="">
          <iframe
            className="responsive-iframe"
            scrolling="no"
            src="https://electionresults.intoday.in/elections/2023/assembly-elections/html/december/exit-poll/exit-poll-tak.html?site=lallantop&v=2.1"
            width="100%"
            height="100%"
          ></iframe>
        </div>
        {postData?.permalink.indexOf("assembly-elections-result-2023") < 0 && (
          <div className="iframe-container2">
            <div className="">
              <iframe
                className="responsive-iframe2"
                src="https://elections.mobiletak.com/tally/all?theme=llt"
                width="100%"
                height="450px"
              ></iframe>
            </div>
          </div>
        )}
      </div> */}
      <ElectionsWidget />
      {/* { publicRuntimeConfig?.electionYear == "2024" &&  <Sponsor color="#d9368b" name="चुनाव" />} */}
      <div className="content-wrapper" style={{ minHeight: "250px" }}>
        <Container>
          <div className="container-row content-container">
            {/* BreadcrumbList removed by harsh */}
            {arraysData.map((articleData, index) => {
              return (
                <div className={`infinite articles ${index}`} key={index}>
                  <div
                    className="container-row py-2 deaktop-header-ad"
                    align="center"
                  >
                    <h5
                      id="ads"
                      style={{
                        fontSize: "11px",
                        color: "#b7b7b7",
                        textAlign: "center",
                        marginBottom: "0px",
                      }}
                    >
                      Advertisement
                    </h5>
                    {indexonScreen === index && size.width > 700 && (
                      <div
                        id="div-gpt-ad-1701945163318-0"
                        style={{
                          minWidth: "300px",
                          minHeight: size.width > 700 ? "100px" : "260px",
                          display: "block !important",
                          alignContent: "center",
                          textAlign: "-webkit-center",
                        }}
                      >
                        <script
                          type="text/javascript"
                          dangerouslySetInnerHTML={{
                            __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})`,
                          }}
                        ></script>
                      </div>
                    )}
                  </div>
                  {/* {index === 0 && size.width <= 599 && ( */}

                  {/* )} */}

                  {router.asPath.includes("show/") ? (
                    <ul className="breadcrumb aa">
                      <li>
                        <a href="/" passHref>
                          <a>
                            <i className="icon-cat-home"></i>
                            <span>
                              <FormattedMessage
                                id="home"
                                defaultMessage="होम"
                              />
                            </span>
                          </a>
                        </a>
                      </li>

                      <li>
                        <a href="/show/all" passHref>
                          <a>
                            <span>
                              <FormattedMessage
                                id="series"
                                defaultMessage="शो"
                              />
                            </span>
                          </a>
                        </a>
                      </li>

                      <li>
                        <a href={`/show/detail/${query?.seriesSlug}`} passHref>
                          {/* <a>
                        <span>{query?.seriesSlug}</span>
                      </a> */}
                          <a>
                            <span>
                              {language === "hi"
                                ? postStateData?.seriesTitleHn
                                : postStateData?.seriesTitle}
                            </span>
                          </a>
                        </a>
                      </li>
                    </ul>
                  ) : (
                    <ul className="breadcrumb-article breadcrumb-article-page">
                      <li>
                        <a href="/" passHref>
                          <a>
                            <i className="icon-cat-home"></i>
                            <span>Home</span>
                          </a>
                        </a>
                      </li>

                      <li>
                        <a
                          href={
                            `/${mainUrl}/${articleData?.categorySlug}`
                            //query: { categoryId: postStateData?.categoryId },
                          }
                          passHref
                        >
                          <a>
                            <span>
                              {language === "hi"
                                ? articleData?.categoryName
                                : articleData?.categoryName}
                            </span>
                          </a>
                        </a>
                      </li>

                      <li>
                        {size?.width >= 780 ? (
                          <span>
                            {language === "hi"
                              ? articleData?.englishTitle.substring(0, 100)
                              : articleData?.englishTitle.substring(0, 100)}
                          </span>
                        ) : (
                          <span>
                            {language === "hi"
                              ? articleData?.englishTitle.substring(0, 30) +
                                "..."
                              : articleData?.englishTitle.substring(0, 30) +
                                "..."}
                          </span>
                        )}
                      </li>
                    </ul>
                  )}
                  <div
                    className={
                      fontSize === "small"
                        ? "card-wrapper new-details-small"
                        : fontSize === "large"
                        ? "card-wrapper new-details-large"
                        : "card-wrapper new-details"
                    }
                    style={{ position: "relative" }}
                  >
                    <div className="card-left custom-card-left">
                      <div className="card-body post-body">
                        <div
                          className={
                            fontSize === "small"
                              ? "news-title-small"
                              : fontSize === "large"
                              ? "news-title-large"
                              : "news-title"
                          }
                        >
                          <h1>{articleData?.title}</h1>
                        </div>
                        <h2>{articleData?.shortText}</h2>

                        {/* <div
                          className="content mb-3"
                          dangerouslySetInnerHTML={{
                            __html: articleData?.shortText,
                          }}
                        ></div> */}
                        {!!articleData?.images?.length && (
                          <div className="news-slider">
                            <Carousel fade indicators={false} controls={false}>
                              {articleData.images.map((imageLink, index) => (
                                <Carousel.Item key={index}>
                                  <div className="image">
                                    <a className="image-thumb">
                                      <img
                                        src={imageLink}
                                        width="810px"
                                        height="492px"
                                        alt="Writer pic"
                                        loading="lazy" 
                                      />
                                    </a>
                                  </div>
                                  <div className="slider-caption">
                                    <Carousel.Caption>
                                      <div className="text">
                                        {/* मुंबई में एक महिला का सैंपल लेता स्वास्थ्य
                    कर्मचारी. फोटो- PTI */}
                                      </div>
                                      <div className="indicators">1/5</div>
                                    </Carousel.Caption>
                                  </div>
                                </Carousel.Item>
                              ))}
                            </Carousel>
                          </div>
                        )}
                        {/* {(postStateData?.type === "video" )&& ( */}
                        {!(size.width > 700) && (
                          <div
                            className="container-row py-2 mobile-header-ad"
                            align="center"
                            // style={{
                            //   minWidth: "300px",
                            //   minHeight: size.width > 600 ? "110px" : "275px",
                            //   display: "block !important",
                            // }}
                          >
                            <div
                              id="ads"
                              style={{
                                fontSize: "11px",
                                color: "#b7b7b7",
                                textAlign: "center",
                                marginBottom: "0px",
                              }}
                            >
                              Advertisement
                            </div>
                            {indexonScreen === index && (
                              <div
                                id="div-gpt-ad-1701946028239-0"
                                style={{
                                  minWidth: "300px",
                                  minHeight: "260px",
                                  display: "block !important",
                                  alignContent: "center",
                                  textAlign: "-webkit-center",
                                }}
                              >
                                <script
                                  type="text/javascript"
                                  dangerouslySetInnerHTML={{
                                    __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})`,
                                  }}
                                ></script>
                              </div>
                            )}
                          </div>
                        )}
                        {articleData?.type === "text" && (
                          <VideoPlayer
                            key={articleData?._id}
                            url={articleData}
                            type={articleData?.type}
                            image_url={articleData?.headingImageUrl}
                            fileLink={
                              articleData?.assetFileLink +
                              `?width=${
                                isFirstTime ? 210 : size.width < 700 ? 360 : 540
                              }`
                            }
                            text={articleData?.imgAltText}
                            caption={articleData?.imgCaption}
                          />
                        )}

                        {articleData?.type === "video" &&
                          !isNaN(aspectRatio) && (
                            <div
                              style={
                                aspectRatio <= 1.99 || aspectRatio >= 2.5
                                  ? { minHeight: "222px" }
                                  : { minHeight: "221px", margin: "0 -2.5rem" }
                              }
                            >
                              {loadPlayer && (
                                <ReactJWPlayer
                                  playerId={`jw-player-${index + 1}`}
                                  playerScript="https://cdn.jwplayer.com/libraries/gtSITKWv.js"
                                  playlist={[
                                    {
                                      file: articleData?.assetFileLink,
                                      image:
                                        articleData?.headingImageUrl +
                                        `?width=${
                                          isFirstTime
                                            ? 150
                                            : aspectRatio >= 2 ||
                                              aspectRatio < 2.5
                                            ? 360
                                            : 540
                                        }`,
                                      title: articleData?.title,
                                    },
                                  ]}
                                  isAutoPlay={false}
                                  isMuted={false}
                                  title={"Sdfd"}
                                  onPlay={() => {
                                    handleVideoPlay(`jw-player-${index + 1}`);
                                    setCurrentPlayer(`jw-player-${index + 1}`);
                                    // console.log("Start video-event");
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Main_Video`;
                                      main_video["eventLabel"] = `Video Starts`;
                                      main_video[
                                        "eventValue"
                                      ] = `${postData.englishTitle}`;
                                      gtag("event", "Native_Video", main_video);
                                    }
                                  }}
                                  onResume={(event) => {
                                    handleVideoPlay(`jw-player-${index + 1}`);
                                    setCurrentPlayer(`jw-player-${index + 1}`);
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Main_Video`;
                                      main_video[
                                        "eventLabel"
                                      ] = `Video Resumes`;
                                      main_video[
                                        "eventValue"
                                      ] = `${postData.englishTitle}`;
                                      gtag("event", "Native_Video", main_video);
                                    }
                                  }}
                                  onPause={() => {
                                    // console.log("Pause video-event");
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Main_Video`;
                                      main_video["eventLabel"] = `Video Paused`;
                                      main_video[
                                        "eventValue"
                                      ] = `${postData.englishTitle}`;
                                      gtag("event", "Native_Video", main_video);
                                    }
                                    // if (typeof window.ga !== "undefined") {
                                    //   ga("create", "G-6DCEWMBVGD", "auto");
                                    //   ga("send", "event", {
                                    //     eventCategory: "JW_Video",
                                    //     eventAction: "Paused",
                                    //     eventLabel: "title",
                                    //     eventValue:
                                    //       "https://www.thelallantop.com/",
                                    //   });
                                    // }
                                  }}
                                  onSeek={(event) => {
                                    // console.log(
                                    //   "Seeking video-event ",
                                    //   event.offset
                                    // );
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Main_Video`;
                                      main_video["eventLabel"] = `Video Seeked`;
                                      main_video[
                                        "eventValue"
                                      ] = `Seeked_to_${event.offset}`;
                                      gtag("event", "Native_Video", main_video);
                                    }
                                  }}
                                  onTwentyFivePercent={() => {
                                    // console.log("Two Five video-event");
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Main_Video`;
                                      main_video[
                                        "eventLabel"
                                      ] = `Video Duration`;
                                      main_video["eventValue"] = `Duration_25%`;
                                      gtag("event", "Native_Video", main_video);
                                    }
                                  }}
                                  // setStreamingPercent((prevState) => ({
                                  //   ...prevState,
                                  //   percent25: true,
                                  // }))

                                  // }
                                  // }
                                  onFiftyPercent={
                                    () => {
                                      // console.log("Fifty percent video-event");
                                      if (typeof window.gtag !== "undefined") {
                                        gtag("create", "G-6DCEWMBVGD", "auto");
                                        let main_video = {};
                                        main_video["send_to"] = `G-6DCEWMBVGD`;
                                        main_video[
                                          "eventCategory"
                                        ] = `Main_Video`;
                                        main_video[
                                          "eventLabel"
                                        ] = `Video Duration`;
                                        main_video[
                                          "eventValue"
                                        ] = `Duration_50%`;
                                        gtag(
                                          "event",
                                          "Native_Video",
                                          main_video
                                        );
                                      }
                                    }
                                    // setStreamingPercent((prevState) => ({
                                    //   ...prevState,
                                    //   percent50: true,
                                    // }))
                                  }
                                  onSeventyFivePercent={() => {
                                    // console.log("Seventxy Five video-event");
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Main_Video`;
                                      main_video[
                                        "eventLabel"
                                      ] = `Video Duration`;
                                      main_video["eventValue"] = `Duration_75%`;
                                      gtag("event", "Native_Video", main_video);
                                    }
                                    // setStreamingPercent((prevState) => ({
                                    //   ...prevState,
                                    //   percent75: true,
                                    // }))
                                  }}
                                  onOneHundredPercent={() => {
                                    // console.log("Hundred video-event");
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Main_Video`;
                                      main_video[
                                        "eventLabel"
                                      ] = `Video Duration`;
                                      main_video[
                                        "eventValue"
                                      ] = `Duration_100%`;
                                      gtag("event", "Native_Video", main_video);
                                    }
                                  }}
                                  className="my-2"
                                />
                              )}
                            </div>
                          )}
                        {articleData?.type === "audio" && (
                          <audio controls>
                            <source
                              src={articleData?.assetFileLink}
                              type="audio/mpeg"
                            />
                          </audio>
                        )}

                        <div
                          className={
                            fontSize === "small"
                              ? "news-options-small display-block author-box"
                              : fontSize === "large"
                              ? "news-options-large display-block author-box"
                              : "news-options display-block author-box"
                          }
                        >
                          <div
                            className="author-section"
                            style={{ display: "flex" }}
                          >
                            <div className="user user-section">
                              <div className="image">
                                <div className="image-thumb">
                                  <img
                                    src={
                                      articleData?.contentAuthors &&
                                      articleData?.contentAuthors[0]
                                        ?.profileImage + "?width=60"
                                    }
                                    width="60"
                                    height="60"
                                    alt="pic"
                                    loading="lazy" 
                                  />
                                </div>
                              </div>

                              <div
                                className="user-detail"
                                style={{ maxWidth: "100%" }}
                              >
                                <a
                                  href={`/authors/${
                                    articleData?.contentAuthors &&
                                    articleData?.contentAuthors[0]?.email?.split(
                                      "@"
                                    )[0]
                                  }`}
                                  passHref
                                >
                                  <a style={{ color: "black" }}>
                                    <div className="name second-author-name">
                                      {articleData?.contentAuthors &&
                                        articleData?.contentAuthors[0]
                                          ?.fullname}
                                    </div>
                                  </a>
                                </a>
                                {!(
                                  articleData?.contentAuthors?.length > 1 ||
                                  articleData?.inputAuthors?.length > 0
                                ) && (
                                  <div className="date date-fix-overflow">
                                    <span className="date-desktop">
                                      {
                                        formatDate(articleData?.publishedAt)
                                          .date
                                      }
                                    </span>
                                    {articleData?.publishedAt?.toString() !==
                                      articleData?.updatedAt?.toString() && (
                                      <span className="date-desktop">
                                        {` `} (
                                        {language === "hi"
                                          ? "अपडेटेड: "
                                          : "Updated: "}
                                        {
                                          formatDate(articleData?.updatedAt)
                                            .date
                                        }
                                        {", "}
                                        {
                                          formatDateIST(articleData?.updatedAt)
                                            .time
                                        }
                                        {" IST"})
                                      </span>
                                    )}
                                    {articleData?.publishedAt?.toString() ===
                                      articleData?.updatedAt?.toString() && (
                                      <span className="date-desktop">
                                        {` `} (
                                        {language === "hi"
                                          ? "पब्लिश्डः: "
                                          : "Published: "}
                                        {/* {
                                          formatDate(articleData?.publishedAt)
                                            .date
                                        }
                                        {", "} */}
                                        {
                                          formatDateIST(
                                            articleData?.publishedAt
                                          ).time
                                        }
                                        {" IST"})
                                      </span>
                                    )}
                                   
                                  </div>
                                )}
                              </div>
                            </div>
                            {articleData?.contentAuthors?.length > 1 && (
                              <div className="user user-section">
                                <div className="image">
                                  <div className="image-thumb">
                                    <img
                                      src={
                                        articleData?.contentAuthors &&
                                        articleData?.contentAuthors[1]
                                          .profileImage
                                      }
                                      width="60"
                                      height="60"
                                      alt="pic"
                                      loading="lazy" 
                                    />
                                  </div>
                                </div>

                                <div
                                  className="user-detail"
                                  style={{ maxWidth: "100%" }}
                                >
                                  <a
                                    href={`/authors/${
                                      articleData?.contentAuthors[1].email.split(
                                        "@"
                                      )[0]
                                    }`}
                                    passHref
                                  >
                                    <a style={{ color: "black" }}>
                                      <div className="name second-author-name">
                                        {
                                          articleData?.contentAuthors[1]
                                            .fullname
                                        }
                                      </div>
                                    </a>
                                  </a>
                                </div>
                              </div>
                            )}
                            {articleData?.contentAuthors?.length === 1 &&
                              articleData?.inputAuthors?.length > 0 && (
                                <div className="user user-section">
                                  <div className="image">
                                    <div className="image-thumb">
                                      <img
                                        src={
                                          "https://www.thelallantop.com/_next/image?url=https%3A%2F%2Fstatic.thelallantop.com%2Fimages%2Fauthor%2F1653057005739_logo.png&w=256&q=75"
                                        }
                                        width="60"
                                        height="60"
                                        alt="pic"
                                        loading="lazy" 
                                      />
                                    </div>
                                  </div>

                                  <div
                                    className="user-detail"
                                    style={{ maxWidth: "inherit" }}
                                  >
                                    <div className="name second-author-name">
                                      {articleData?.inputAuthors[0]}
                                    </div>
                                  </div>
                                </div>
                              )}

                            <div className="options mobile-options d-visible-icons">
                              {/* {
                                size.width > 700 && (
                                  <a
                                    href="https://news.google.com/publications/CAAqBwgKMLqg_Qowk8r0Ag"
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ marginRight: "25px" }}
                                  >
                                    <img
                                      src="/assets/images/google_news.png"
                                      width="40px"
                                    ></img>
                                  </a>
                                )
                                // </a>
                                // </div>
                              } */}
                              <FontSize
                                setFontSize={setFontSize}
                                fontSize={fontSize}
                              />

                              <div className="btns">
                                <i
                                  onClick={() => {
                                    handleBookmark(
                                      articleData?.postId || articleData?._id,
                                      articleData?.type,
                                      index
                                    );
                                  }}
                                  title="bookmark"
                                  style={{ fontWeight: "600" }}
                                  className={`icon-bookmark${
                                    bookmarkArticleArray[index]?.isBookmarked
                                      ? "-fill"
                                      : ""
                                  }`}
                                  role={"button"}
                                  aria-label="Bookmark Toggle"
                                ></i>
                              </div>
                              {/* commented share  */}
                              <div className="btns">
                                <i
                                  onClick={() => {
                                    handleShare(articleData);
                                  }}
                                  title="share"
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "2.1rem",
                                  }}
                                  className="icon-share"
                                  aria-label="Share Button"
                                  role="link"
                                ></i>
                              </div>
                            </div>
                          </div>
                          {console.log("Video Page data ", articleData)}
                          {(articleData?.contentAuthors?.length > 1 ||
                            articleData?.inputAuthors?.length > 0) && (
                            <div className="date date-fix-overflow">
                              <span className="date-desktop">
                                {formatDate(articleData?.publishedAt).date}
                              </span>
                              {articleData?.publishedAt?.toString() !==
                                articleData?.updatedAt?.toString() && (
                                <span className="date-desktop">
                                  {` `} (
                                  {language === "hi"
                                    ? "अपडेटेड: "
                                    : "Updated: "}
                                  {formatDate(articleData?.updatedAt).date}
                                  {", "}
                                  {formatDateIST(articleData?.updatedAt).time}
                                  {" IST"})
                                </span>
                              )}
                              {articleData?.publishedAt?.toString() ===
                                articleData?.updatedAt?.toString() && (
                                <span className="date-desktop">
                                  {` `} (
                                  {language === "hi"
                                    ? "पब्लिश्डः: "
                                    : "Published: "}
                                  {/* {formatDate(articleData?.publishedAt).date}
                                  {", "} */}
                                  {formatDateIST(articleData?.publishedAt).time}
                                  {" IST"})
                                </span>
                              )}
                              {/* {console.log("All data of article ",articleData)}
                          <div className="date-mobile">
                            {language === "hi" ? "अपडेटेड: " : "Updated: "}
                            {formatDate(articleData?.updatedAt).date}{" "}
                            {formatDateIST(articleData?.updatedAt).time}
                            {" IST"}
                          </div> */}
                              {/* )} */}
                            </div>
                          )}

                          <div className="options mobile-options m-visible-icons">
                            <FontSize
                              setFontSize={setFontSize}
                              fontSize={fontSize}
                            />

                            <div className="btns">
                              <i
                                onClick={() => {
                                  handleBookmark(
                                    articleData?.postId || articleData?._id,
                                    articleData?.type,
                                    index
                                  );
                                }}
                                title="bookmark"
                                style={{ fontWeight: "600" }}
                                className={`icon-bookmark${
                                  bookmarkArticleArray[index]?.isBookmarked
                                    ? "-fill"
                                    : ""
                                }`}
                                role={"button"}
                                aria-label="Bookmark Toggle"
                              ></i>
                            </div>
                            <div className="btns">
                              <i
                                onClick={() => {
                                  handleShare(articleData);
                                }}
                                title="share"
                                style={{
                                  fontWeight: "600",
                                  fontSize: "2.1rem",
                                }}
                                className="icon-share"
                                aria-label="Share Button"
                                role="link"
                              ></i>
                            </div>
                            <div className="btns d-flex align-items-center">
                              <Image
                                aria-label="Whatsapp Share Button"
                                role="link"
                                title="whatsapp"
                                onClick={() => {
                                  shareLinkToWhatsApp(articleData);
                                }}
                                src="/assets/images/whatsapp2.png"
                                width={20}
                                height={20}
                                alt="whatsapp share"
                              />
                            </div>
                          </div>
                        </div>

                        {pageScrolled && <ArticleHTML
                          postData={articleData}
                          postStateData={articleData}
                          isFirstTime={isFirstTime}
                          indexonScreen={indexonScreen}
                          relatedArticles={relatedArticles}
                          articleIndex={index}
                          showMore={showMore[index]}
                          handleShowMore={() => handleReadMore(index)}
                        />}

                        <div
                          style={
                            showMore[index]
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >
                          {/* {!isFirstTime && (
                            <>
                              <div
                                className="checkDesktopOrNot"
                                onClick={() =>
                                  router.push(
                                    "https://adda.thelallantop.com/?userId=%22home%22"
                                  )
                                }
                                style={{
                                  minHeight: "65px",
                                  marginTop: "4px",
                                  marginBottom: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  className="one-px-solid-br"
                                  src={`https://static.thelallantop.com/images/post/1698922401896_774x172.webp?${
                                    isFirstTime ? "width=200" : ""
                                  }`}
                                  alt="adda-banner"
                                  style={{ borderRadius: "1rem" }}
                                />
                              </div>
                            </>
                          )} */}
                          {/* {!isFirstTime && (
                            <div
                              className="checkMobileOrNot"
                              onClick={() =>
                                router.push(
                                  "https://adda.thelallantop.com/?userId=%22home%22"
                                )
                              }
                              style={{ minHeight: "175px", cursor: "pointer" }}
                            >
                              <img
                                style={{ minWidth: "100%" }}
                                src={`https://static.thelallantop.com/images/post/1698921639782_414x212.webp?${
                                  isFirstTime ? "width=100" : ""
                                }`}
                                alt="adda-banner"
                              />
                            </div>
                          )} */}

                          <p ref={jwRef} style={{ marginTop: "10px" }}>
                            <strong>{articleData?.embedTitle}</strong>
                          </p>
                          {articleData?.embedUrl && isJWVisible && (
                            <div
                              style={
                                size.width > 700
                                  ? { minHeight: "222px" }
                                  : { minHeight: "221px" }
                              }
                            >
                              {loadPlayer && (
                                <ReactJWPlayer
                                  playerId={`jw-player-${index + 1}`}
                                  playerScript="https://cdn.jwplayer.com/libraries/gtSITKWv.js"
                                  onPlay={() => {
                                    handleVideoPlay(`jw-player-${index + 1}`);
                                    setCurrentPlayer(`jw-player-${index + 1}`);
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Embed_Video`;
                                      main_video["eventLabel"] = `Video Starts`;
                                      main_video[
                                        "eventValue"
                                      ] = `${postData.englishTitle}`;
                                      gtag("event", "Embed_Video", main_video);
                                    }
                                  }}
                                  onResume={(event) => {
                                    handleVideoPlay(`jw-player-${index + 1}`);
                                    setCurrentPlayer(`jw-player-${index + 1}`);
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Embed_Video`;
                                      main_video[
                                        "eventLabel"
                                      ] = `Video Resumes`;
                                      main_video[
                                        "eventValue"
                                      ] = `${postData.englishTitle}`;
                                      gtag("event", "Embed_Video", main_video);
                                    }
                                  }}
                                  onPause={() => {
                                    // console.log("Pause video-event");
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Embed_Video`;
                                      main_video["eventLabel"] = `Video Paused`;
                                      main_video[
                                        "eventValue"
                                      ] = `${postData.englishTitle}`;
                                      gtag("event", "Embed_Video", main_video);
                                    }
                                    // if (typeof window.ga !== "undefined") {
                                    //   ga("create", "G-6DCEWMBVGD", "auto");
                                    //   ga("send", "event", {
                                    //     eventCategory: "JW_Video",
                                    //     eventAction: "Paused",
                                    //     eventLabel: "title",
                                    //     eventValue:
                                    //       "https://www.thelallantop.com/",
                                    //   });
                                    // }
                                  }}
                                  onSeek={(event) => {
                                    // console.log(
                                    //   "Seeking video-event ",
                                    //   event.offset
                                    // );
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Embed_Video`;
                                      main_video["eventLabel"] = `Video Seeked`;
                                      main_video[
                                        "eventValue"
                                      ] = `Seeked_to_${event.offset}`;
                                      gtag("event", "Embed_Video", main_video);
                                    }
                                  }}
                                  onTwentyFivePercent={() => {
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Embed_Video`;
                                      main_video[
                                        "eventLabel"
                                      ] = `Video Duration`;
                                      main_video["eventValue"] = `Duration_25%`;
                                      gtag("event", "Embed_Video", main_video);
                                    }
                                  }}
                                  // setStreamingPercent((prevState) => ({
                                  //   ...prevState,
                                  //   percent25: true,
                                  // }))

                                  // }
                                  // }
                                  onFiftyPercent={
                                    () => {
                                      if (typeof window.gtag !== "undefined") {
                                        gtag("create", "G-6DCEWMBVGD", "auto");
                                        let main_video = {};
                                        main_video["send_to"] = `G-6DCEWMBVGD`;
                                        main_video[
                                          "eventCategory"
                                        ] = `Embed_Video`;
                                        main_video[
                                          "eventLabel"
                                        ] = `Video Duration`;
                                        main_video[
                                          "eventValue"
                                        ] = `Duration_50%`;
                                        gtag(
                                          "event",
                                          "Embed_Video",
                                          main_video
                                        );
                                      }
                                    }
                                    // setStreamingPercent((prevState) => ({
                                    //   ...prevState,
                                    //   percent50: true,
                                    // }))
                                  }
                                  onSeventyFivePercent={() => {
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Embed_Video`;
                                      main_video[
                                        "eventLabel"
                                      ] = `Video Duration`;
                                      main_video["eventValue"] = `Duration_75%`;
                                      gtag("event", "Embed_Video", main_video);
                                    }
                                    // setStreamingPercent((prevState) => ({
                                    //   ...prevState,
                                    //   percent75: true,
                                    // }))
                                  }}
                                  onOneHundredPercent={() => {
                                    if (typeof window.gtag !== "undefined") {
                                      gtag("create", "G-6DCEWMBVGD", "auto");
                                      let main_video = {};
                                      main_video["send_to"] = `G-6DCEWMBVGD`;
                                      main_video[
                                        "eventCategory"
                                      ] = `Embed_Video`;
                                      main_video[
                                        "eventLabel"
                                      ] = `Video Duration`;
                                      main_video[
                                        "eventValue"
                                      ] = `Duration_100%`;
                                      gtag("event", "Embed_Video", main_video);
                                    }
                                  }}
                                  playlist={[
                                    {
                                      file: articleData?.embedUrl,
                                      image: articleData?.embedThumbnail,
                                    },
                                  ]}
                                  // file= {postStateData?.embedUrl}
                                  isAutoPlay={false}
                                  isMuted={false}
                                  className="my-2"
                                />
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        style={
                          showMore[index]
                            ? { display: "block" }
                            : { display: "none" }
                        }
                      >
                        {index === 0 && (
                          <div className="first-article-observer"></div>
                        )}
                        <CommentSection
                          postData={articleData}
                          postStateData={articleData}
                          ref={ref}
                          language={language}
                          setLoginPrompt={setLoginPrompt}
                          commentIndex={index}
                          isVisible={showMore[index]}
                          pageScrolled={pageScrolled}
                        />
                        {
                          <FAQComponent
                            data={articleData?.faqs}
                            title={articleData?.title}
                          />
                        }
                        {/* {!!articleData?.hashtags?.length > 0 && (
                          <div className="card-body news-hashtag">
                            <h2
                              className="title text-black mb-2"
                              style={{ fontWeight: "600" }}
                            >
                              <FormattedMessage
                                id="hashtags_mentioned"
                                defaultMessage="इस पोस्ट से जुड़े हुए हैशटैग्स"
                              />
                            </h2>
                            <ul className="hashtags-list">
                              {articleData?.hashtags?.map((hashTag, index) => (
                                <li key={index}>
                                  <a
                                    href={{
                                      pathname: `/hashtags/${hashTag}/text`,
                                    }}
                                  >
                                    <a>{`#${hashTag}`}</a>
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )} */}

                        {articleData?.topicItems?.length > 0 && (
                          <div className="card-body news-hashtag">
                            <h2
                              className="title text-black mb-2"
                              style={{ fontWeight: "600" }}
                            >
                              <FormattedMessage
                                id="topics_mentioned"
                                defaultMessage="इस पोस्ट से जुड़े हुए हैशटैग्स"
                              />
                            </h2>
                            <ul className="hashtags-list">
                              {articleData?.topicItems?.map((topic, index) => (
                                <li key={index}>
                                  <a href={`/topic/${topic?.slug}`}>
                                    <a>
                                      {topic?.title}
                                      {index !==
                                        articleData?.topicItems?.length - 1 &&
                                        ","}
                                    </a>
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                    {size.width < 700 && (
                      <a href="https://news.google.com/publications/CAAqBwgKMLqg_Qowk8r0Ag">
                        <a target="_blank">
                          <div className="google-news-container">
                            <img
                              src="https://static.thelallantop.com/images/post/1690365910228_8b5d7bf402d51d61d72ce54ef1585008f6a45f45.webp?width=50"
                              alt="google news"
                              width="34px"
                              height="34px"
                              className="google-news-icon"
                              loading="lazy" 
                            />
                          </div>
                        </a>
                      </a>
                    )}
                    {size.width < 700 && (
                      // <a href="https://whatsapp.com/channel/0029Va9lDkJDp2QAHxZogJ2r">
                      // <a target="_blank">
                      <div
                        className="whatsapp-channel-container"
                        onClick={() => shareLinkToWhatsApp()}
                      >
                        <img
                          src="https://static.thelallantop.com/images/post/1695284130458_whatsapp.webp?width=50"
                          alt="whatsapp channel"
                          width="34px"
                          height="34px"
                          className="whatsapp-channel-icon"
                          loading="lazy" 
                        />
                      </div>
                      // </a>
                      // </a>
                    )}
                    {size.width < 700 && (
                      <a href="https://share.thelallantop.com/izPo">
                        <a target="_blank">
                          <div
                            className={
                              hideAppButton
                                ? "collapseOpenApp"
                                : "open_app_container"
                            }
                          >
                            {hideAppButton ? "" : "Open App"}
                          </div>
                        </a>
                      </a>
                    )}

                    {size.width <= 700 ? 
                    (
                      index === 4 && (
                        <div className="card-right min-width-ads card-right-ad ">
                          <div
                            className="bottom-ads container-row py-2 "
                            align="center"
                          >
                            <p
                              id="ads"
                              style={{
                                fontSize: "11px",
                                color: "#b7b7b7",
                                marginBottom: "0px",
                              }}
                            >
                              Advertisement
                            </p>
                            <div
                              id="div-gpt-ad-1701945220410-1"
                              style={{
                                minWidth: "300px",
                                minHeight: "100px",
                                display: "block !important",
                                alignContent: "center",
                                textAlign: "-webkit-center",
                              }}
                            >
                              <script
                                type="text/javascript"
                                dangerouslySetInnerHTML={{
                                  __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})`,
                                }}
                              ></script>
                            </div>
                          </div>

                          {/* {!!trendingData.entities?.length > 0 && (
                            <div>
                              <TrendingToday data={trendingData.entities} />
                            </div>
                          )}

                          <Container
                            align="center"
                            style={{ marginTop: "1rem" }}
                          >
                            {
                              <div
                                className="container-row py-2"
                                align="center"
                              >
                                <p
                                  id="ads"
                                  style={{
                                    fontSize: "11px",
                                    color: "#b7b7b7",
                                    marginBottom: "0px",
                                  }}
                                >
                                  Advertisement
                                </p>
                                <div
                                  id={
                                    size.width > 600
                                      ? "div-gpt-ad-1701945220410-3"
                                      : "div-gpt-ad-1701946028239-3"
                                  }
                                  style={{
                                    minWidth: "300px",
                                    minHeight: "90px",
                                    display: "block !important",
                                  }}
                                >
                                  <script
                                    type="text/javascript"
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        size.width > 600
                                          ? `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-3')})`
                                          : `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-3')})`,
                                    }}
                                  ></script>
                                </div>
                              </div>
                            }
                          </Container> */}
                        </div>
                      )
                    ) : (
                      <div className="card-right min-width-ads card-right-ad">
                        {/* <div
                          className="checkDesktopOrNot"
                          onClick={() =>
                            router.push(
                              "https://adda.thelallantop.com/?userId=%22home%22"
                            )
                          }
                          style={{
                            minHeight: "175px",
                            marginTop: "2px",
                            cursor: "pointer",
                          }}
                        >
                          <img
                            style={{ minWidth: "100%" }}
                            src={`https://static.thelallantop.com/images/post/1698921639782_414x212.webp?${
                              isFirstTime ? "width=200" : ""
                            }`}
                            alt="adda-banner"
                          />
                        </div> */}
                        {
                          <div
                            className="container-row py-2"
                            align="center"
                            style={{
                              minWidth: "300px",
                              minHeight: "250px",
                              display: "block !important",
                              // position: "sticky",
                              // top: "32px",
                              // zIndex: "99",
                              // background: "white",
                            }}
                          >
                            <p
                              id="ads"
                              style={{
                                fontSize: "11px",
                                color: "#b7b7b7",
                                marginBottom: "0px",
                              }}
                            >
                              Advertisement
                            </p>
                            {indexonScreen === index && size.width > 700 && (
                              <div
                                id="div-gpt-ad-1701945220410-0"
                                style={{
                                  minWidth: "300px",
                                  minHeight: "260px",
                                  display: "block !important",
                                  alignContent: "center",
                                  textAlign: "-webkit-center",
                                }}
                              >
                                <script
                                  type="text/javascript"
                                  dangerouslySetInnerHTML={{
                                    __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-0')})`,
                                  }}
                                ></script>
                              </div>
                            )}
                            {indexonScreen === index && size.width < 700 && (
                              <div id="div-gpt-ad-1701946028239-1">
                                <script
                                  type="text/javascript"
                                  dangerouslySetInnerHTML={{
                                    __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})`,
                                  }}
                                ></script>
                              </div>
                            )}
                          </div>
                        }

                        {index === 0 &&
                          homePageVideos?.entities?.length > 0 && (
                            <div className="chunav-yatra-article">
                              <div
                                className="electionYatra-outer-home-article"
                                style={{
                                  backgroundColor:
                                    homePageVideos?.backgroundColor,
                                }}
                              >
                                <div className="electionYatra-header-article">
                                  <div>
                                    <img
                                      src={homePageVideos?.icon}
                                      width="30px"
                                      height="30px"
                                      alt="election-icon"
                                      loading="lazy" 
                                    ></img>
                                    <span
                                      style={{
                                        marginLeft: "10px",
                                        fontSize: "20px",
                                      }}
                                    >
                                      {language === "hi"
                                        ? homePageVideos?.titleHn
                                        : homePageVideos?.title}
                                    </span>
                                  </div>
                                  <div
                                    className="election-aurDekhe-article"
                                    onClick={() =>
                                      router.push("/topic/chunav-yatra-2024")
                                    }
                                  >
                                    <span style={{ marginRight: "10px" }}>
                                      {language === "hi"
                                        ? "और देखें"
                                        : "see more"}
                                    </span>
                                    <img
                                      src="/assets/images/arrow.png"
                                      width="15px"
                                      height="15px"
                                      loading="lazy" 
                                    ></img>
                                  </div>
                                </div>
                                <div className="electionYatra-columns-article">
                                  <a
                                    href={`${homePageVideos?.entities[0]?.permalink}`}
                                  >
                                    <div className="electionYatra-second-article election-mobile-article">
                                      <div
                                        className="electionYatra-second-top-article"
                                        style={{ position: "relative" }}
                                      >
                                        <img
                                          src={
                                            homePageVideos?.entities[0]
                                              ?.headingImageUrl
                                          }
                                          loading="lazy" 
                                        ></img>
                                        <i
                                          className="icon-play-circle"
                                          width="500px"
                                          height="500px"
                                          style={{
                                            color: "white",
                                            position: "absolute",
                                            left: "2px",
                                            bottom: "-5px",
                                            width: "500px",
                                          }}
                                        ></i>
                                      </div>
                                      <div
                                        className="electionYatra-second-bottom-article"
                                        style={{ fontSize: "17px" }}
                                      >
                                        <h2>
                                          {homePageVideos?.entities[0]?.title}
                                        </h2>
                                        {/* <h4>{electionTopicData[0]?.shortText}</h4> */}
                                      </div>
                                    </div>
                                  </a>

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {homePageVideos?.entities
                                      .slice(1)
                                      .map((x, index) => {
                                        return (
                                          <a
                                            href={`${x?.permalink}`}
                                            key={index}
                                          >
                                            <div className="electionYatra-first-article">
                                              <div className="electionYatra-first-div-article">
                                                <div
                                                  style={{
                                                    flex: "0 0 40%",
                                                    position: "relative",
                                                    justifyContent: "center",
                                                    alignContent: "center",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <img
                                                    src={x?.headingImageUrl}
                                                    loading="lazy" 
                                                    // width="150px"
                                                    // height="66px"
                                                  ></img>
                                                  <i
                                                    className="icon-play-circle"
                                                    style={{
                                                      color: "white",
                                                      position: "absolute",
                                                      left: "2px",
                                                      bottom: "-5px",
                                                    }}
                                                  ></i>
                                                </div>
                                                <div
                                                  className="electionYatra-first-div-right-article"
                                                  style={{ flex: "0 0 60%" }}
                                                >
                                                  <div>
                                                    {/* <h5
                            style={{
                              margin: "0",
                              color: "#FFD300",
                            }}
                          >
                            LOK SABHA 2024
                          </h5> */}
                                                    <div
                                                      style={{
                                                        overflow: "hidden",
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          display:
                                                            "-webkit-box",
                                                          lineHeight: "20px",
                                                          WebkitLineClamp: "3",
                                                          WebkitBoxOrient:
                                                            "vertical",
                                                          fontSize: "16px",
                                                        }}
                                                        className="chunav-yatra-small-title-article"
                                                      >
                                                        {x?.title}
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      gap: "1rem",
                                                    }}
                                                  >
                                                    {/* <div
                                                style={{
                                                  display: "flex",
                                                  gap: "5px",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <img
                                                  src="/assets/images/story-comment.png"
                                                  style={{
                                                    marginBottom: "2px",
                                                  }}
                                                  width="18px"
                                                  height="18px"
                                                ></img>
                                                <p style={{ margin: "0" }}>
                                                  160
                                                </p>
                                              </div> */}
                                                    {/* <div
                                                style={{
                                                  display: "flex",
                                                  gap: "5px",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <img
                                                  src="/assets/images/story-eye.png"
                                                  style={{
                                                    marginBottom: "2px",
                                                  }}
                                                  width="20px"
                                                  height="20px"
                                                ></img>
                                                <p style={{ margin: "0" }}>
                                                  {" "}
                                                  160
                                                </p>
                                              </div> */}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </a>
                                        );
                                      })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        {indexonScreen === index && index === 0 && (
                          <Container
                            align="center"
                            style={{
                              minWidth: "300px",
                              minHeight: "250px",
                              display: "block !important",
                              // position: "sticky",
                              // top: "32px",
                              // zIndex: "99",
                              // background: "white",
                            }}
                          >
                            {
                              <div
                                className="container-row py-2"
                                align="center"
                              >
                                <p
                                  id="ads"
                                  style={{
                                    fontSize: "11px",
                                    color: "#b7b7b7",
                                    marginBottom: "0px",
                                  }}
                                >
                                  Advertisement-3
                                </p>
                                <div
                                  id="div-gpt-ad-1701945864013-0"
                                  style={{
                                    minWidth: "300px",
                                    minHeight: "260px",
                                    display: "block !important",
                                    alignContent: "center",
                                    textAlign: "-webkit-center",
                                  }}
                                >
                                  <script
                                    type="text/javascript"
                                    dangerouslySetInnerHTML={{
                                      __html: `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945864013-0')})`,
                                    }}
                                  ></script>
                                </div>
                              </div>
                            }
                          </Container>
                        )}
                      </div>
                    )}
                  </div>
                  {index <= 3 && arraysData.length > 1 && (
                    <div
                      separator=""
                      className="amp-next-page-default-separator"
                      tabIndex="0"
                    >
                      {" "}
                      Next <span className="triangle_down"> </span>{" "}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Container>
        {pageScrolled && !!trendingData.entities?.length > 0 && size.width < 700 && (
          <div style={{ paddingTop: "20px", background: "white" }}>
            <TrendingToday data={trendingData.entities} />
          </div>
        )}

        <Container align="center" style={{ marginTop: "1rem" }}>
          {
            <div className="container-row py-2" align="center">
              <p
                id="ads"
                style={{
                  fontSize: "11px",
                  color: "#b7b7b7",
                  marginBottom: "0px",
                }}
              >
                Advertisement
              </p>
              <div
                id={
                  size.width > 700
                    ? "div-gpt-ad-1701945220410-3"
                    : "div-gpt-ad-1701946028239-3"
                }
                style={{
                  minWidth: "300px",
                  minHeight: size.width > 700 ? "100px" : "260px",
                  display: "block !important",
                  alignContent: "center",
                  textAlign: "-webkit-center",
                }}
              >
                <script
                  type="text/javascript"
                  dangerouslySetInnerHTML={{
                    __html:
                      size.width > 700
                        ? `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-3')})`
                        : `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-3')})`,
                  }}
                ></script>
              </div>
            </div>
          }
        </Container>
      </div>
      {/* <QuickLinks/> */}

      {/* <FAQComponent data={postData?.faqs} /> */}
      <div id="taboola-below-article-thumbnails"></div>

      {loginPrompt && <CommentPopup
        showModal={loginPrompt}
        onClose={() => setLoginPrompt(false)}
      />}

      {loginShow && (
        <CustomPopup
          showModal={loginShow}
          onClose={() => setLoginShow(false)}
        />
      )}
      {/* <Modal contentClassName="modal login-next" show={showModal} centered>
        <Modal.Body>
          <div className="RegiModalBody">
            <div>
              <h4>
                <FormattedMessage
                  id="update_feature"
                  defaultMessage="यह फीचर इस्तेमाल करने के लिए प्रोफ़ाइल अपडेट करें"
                />
              </h4>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="modalfooter">
            <div className="d-flex justify-content-between flex-direction-row">
              <Button
                variant="primary"
                type="button"
                onClick={() =>
                  router.push({
                    pathname: "/loading/profile",
                    query: { callbackUrl: router.asPath },
                  })
                }
              >
                {" "}
                <FormattedMessage
                  id="update_profile1"
                  defaultMessage="अपडेट प्रोफ़ाइल"
                />
              </Button>
              <Button
                variant="primary"
                type="button"
                onClick={() => setShowModal(false)}
              >
                {" "}
                <FormattedMessage id="close" defaultMessage="बंद करें" />
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal> */}

      {/* App redirection popup */}
      {/* <Modal
        contentClassName="modal login-next"
        show={showAppRedirection}
        centered
      >
        <Modal.Body>
          <div className="RegiModalBody">
            <div
              role="button"
              className="redirect-app-close"
              onClick={() => setShowAppRedirection(false)}
            >
              <span className="icon-close"></span>
            </div>
            <div className="flex-center">
              <img
                src="/assets/images/lallatop-logo-m.svg"
                alt="lallantop logo"
              />
            </div>
            <div className="redirect-app-body">
              <h4>
                <FormattedMessage
                  id="redirect_app_body"
                  defaultMessage="Continue reading to app to get better experience"
                />
              </h4>
            </div>
          </div>
          <div className="modalfooter">
            <div className="d-flex justify-content-center flex-direction-row">
              <Button
                variant="primary"
                type="button"
                onClick={
                  () => router.push(postData?.shareLink)
                  // https://onelink.to/hsnwrm
                }
              >
                <FormattedMessage id="redirect_app" defaultMessage="Open" />
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}


      { openShareModal && <SharePopup openShareModal={openShareModal} setOpenShareModal={setOpenShareModal}/>}

      {/* removing this share popup  */}

      {/* <Modal
        show={openShareModal}
        fullscreen={false}
        centered
        size="sm"
        onHide={() => setOpenShareModal(false)}
      >
        <div className="row p-2">
          <div className="col-6">Social Share</div>
          <div className="col-6 text-end">
            <div role={"button"} onClick={() => setOpenShareModal(false)}>
              <span className="icon-close"></span>
            </div>
          </div>
        </div>

        <Modal.Body>
          <div align="center">
            <FacebookShareButton quote={shareData.text} url={shareData.url}>
              <FacebookIcon className="me-1" size={32} round />
            </FacebookShareButton>

            <TwitterShareButton title={shareData.text} url={shareData.url}>
              <TwitterIcon className="me-1" size={32} round />
            </TwitterShareButton>

            <EmailShareButton
              url={shareData.url}
              subject={shareData.text}
              body={shareData.url}
            >
              <EmailIcon className="me-1" size={32} round />
            </EmailShareButton>

            <LinkedinShareButton title={shareData.text} url={shareData.url}>
              <LinkedinIcon className="me-1" size={32} round />
            </LinkedinShareButton>
            <WhatsappShareButton url={shareData.url} title={shareData.text}>
              <WhatsappIcon className="me-1" size={32} round />
            </WhatsappShareButton>
            <hr />
            <span style={{ fontSize: "13px" }} className="text-dark">
              <span id="cpy">Copy</span> to Clipboard{" "}
              <i className="las la-clipboard la-lg"></i>
            </span>
            <input
              style={{ fontSize: "13px" }}
              onClick={() => {
                let et = document.getElementById("copy");
                et.select();
                document.execCommand("copy");
                document.getElementById("cpy").textContent = "Copied";
              }}
              id="copy"
              value={shareData.url}
              type="text"
              readOnly
              className="form-control"
            />
          </div>
        </Modal.Body>
      </Modal> */}
      {!isFirstTime && (
        <Script id="taboola">
          {`
            window._taboola = window._taboola || [];
            _taboola.push({article:'auto'});
            !function (e, f, u, i) {
            if (!document.getElementById(i)){
            e.async = 1;
            e.src = u;
            e.id = i;
            f.parentNode.insertBefore(e, f);
            }
            }(document.createElement('script'),
            document.getElementsByTagName('script')[0],
            '//cdn.taboola.com/libtrc/indiatoday-thelallantop/loader.js',
            'tb_loader_script');
            if(window.performance && typeof window.performance.mark == 'function')
            {window.performance.mark('tbl_ic');}
            `}
        </Script>
      )}

      {router.asPath.includes("show/") ? (
        <script
          id="my-script-show"
          type="application/ld+json"
          defer = {true}
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  item: {
                    name: "शो",
                    "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}show/all`,
                  },
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  item: {
                    name: `${query?.seriesSlug}`,
                    "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}show/detail/${query?.seriesSlug}`,
                  },
                },
              ],
            }),
          }}
        ></script>
      ) : (
        <script
          id="my-script-detail"
          type="application/ld+json"
          defer = {true}
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  item: {
                    "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}`,
                    name: `${language === "hi" ? "होम" : "Home"}`,
                  },
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  item: {
                    name: `${
                      language === "hi"
                        ? postData?.categoryNameHn
                        : postData?.categoryName
                    }`,
                    "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}${mainUrl}/${postData?.categorySlug}`,
                  },
                },

                {
                  "@type": "ListItem",
                  position: 3,
                  item: {
                    name: `${postData?.englishTitle}`,
                    "@id": `${postData?.permalink}`,
                  },
                },
              ],
            }),
          }}
        ></script>
      )}
      {postData && postData?.type === "text" ? (
        <>
          <script
            id="my-script2"
            type="application/ld+json"
            defer = {true}
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "NewsArticle",
           
                mainEntityOfPage: {
                  "@type": "WebPage",
                  "@id": `${
                    postData?.permalink ? postData?.permalink : ""

                  }`,
                },
                headline: `${postData?.seoData?.metaTitle}`,
                description: `${postData?.seoData?.metaDescription}`,
                inLanguage: "hi",
                articleBody: `${postData?.articleHTMLPlainText}`,
                keywords: `${keywords ? keywords : ""}`,
                image: {
                  "@type": "ImageObject",
                  height: 720,
                  width: 1280,
                  url: `${
                    postData?.headingImageUrl ? postData?.headingImageUrl : ""
                  }`,
                },
                datePublished: `${
                  postData?.publishedAt ? postData?.publishedAtIST : ""
                }`,
                dateModified: `${
                  postData?.updatedAt ? postData?.updatedAtIST : ""
                }`,
                // articleBody: `${}`,

                author: {
                  "@type": "Person",
                  name: `${
                    postData?.createdByName ? postData?.createdByName : ""
                  }`,
                  url: `${process.env.NEXT_PUBLIC_AUTH_URL}authors/${authorName}`,
                },
                publisher: {
                  "@type": "Organization",
                  name: "The Lallantop",
                  url: "https://www.thelallantop.com/",
                  logo: {
                    "@type": "ImageObject",
                    url: "https://www.thelallantop.com/assets/images/lallatop-logo.svg",
                    height: 60,
                    width: 600,
                  },
                },
              }),
            }}
          ></script>
        </>
      ) : postData && postData?.type === "video" ? (
        <script
          id="my-script2"
          type="application/ld+json"
          defer = {true}
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "VideoObject",
              name: `${postData?.title ? postData?.title : ""}`,
              headline: `${
                postData?.seoData?.metaTitle ? postData?.seoData?.metaTitle : ""
              }`,
              description: `${
                postData?.seoData?.metaDescription
                  ? postData?.seoData?.metaDescription
                  : ""
              }`,
              url: `${postData?.permalink ? postData?.permalink : ""}`,
              datePublished: `${
                postData?.publishedAt ? postData?.publishedAtIST : ""
              }`,
              dateModified: `${
                postData?.updatedAt ? postData?.updatedAtIST : ""
              }`,
              uploadDate: `${
                postData?.publishedAt ? postData?.publishedAtIST : ""
              }`,
              keywords: `${keywords ? keywords : ""}`,
              thumbnailUrl: `${
                postData?.headingImageUrl
                  ? postData?.headingImageUrl
                  : "https://static.thelallantop.com/images/post/1693311123087_llt-default-backdrop.webp"
              }`,
              contentUrl: `${
                postData?.assetFileLink
                  ? postData?.assetFileLink.includes(".m3u8")
                    ? postData?.assetFileLink.replace(".m3u8", ".mp4")
                    : postData?.assetFileLink
                  : ""
              }`,
              embedUrl: `${
                postData?.assetFileLink
                  ? postData?.assetFileLink.includes(".m3u8")
                    ? postData?.assetFileLink.replace(".m3u8", ".mp4")
                    : postData?.assetFileLink
                  : ""
              }`,
              duration: `${postData?.duration ? postData?.duration : ""}`,
              author: {
                "@type": "Person",
                name: `${
                  postData?.createdByName ? postData?.createdByName : ""
                }`,
                url: `${process.env.NEXT_PUBLIC_AUTH_URL}authors/${authorName}`,
              },
              publisher: {
                "@type": "Organization",
                name: "Lallantop",
                logo: {
                  "@type": "ImageObject",
                  url: "https://www.thelallantop.com/assets/images/lallatop-logo.svg",
                  height: 60,
                  width: 600,
                },
              },
              potentialAction: {
                "@type": "SeekToAction",
                target: {
                  "@type": "EntryPoint",
                  urlTemplate: `${
                    postData?.permalink
                      ? postData?.permalink + "?t={seek_to_second_number}"
                      : ""
                  }`,
                },
                "startOffset-input": {
                  "@type": "PropertyValueSpecification",
                  valueRequired: "http://schema.org/True",
                  valueName: "seek_to_second_number",
                },
              },
            }),
          }}
        ></script>
      ) : null}
      <script
        type="application/ld+json"
        defer = {true}
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ProfilePage",
            mainEntity: {
              "@type": "Person",
              "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}authors/${
                postData?.contentAuthors[0].email.split("@")[0]
              }`,
              name: `${postData?.contentAuthors[0].fullname}`,
            },
            hasPart: {
              "@type": "Article",
              headline: `${postData?.title}`,
              url: `${postData?.seoData?.canonicalURL}`,
              datePublished: `${postData?.publishedAt}`,
              author: {
                "@type": "Person",
                "@id": `${process.env.NEXT_PUBLIC_AUTH_URL}authors/${
                  postData?.contentAuthors[0].email.split("@")[0]
                }`,
                name: `${postData?.contentAuthors[0].fullname}`,
              },
            },
          }),
        }}
      ></script>
      {postData?.additionalSchemas?.length > 0 && <script
          id="my-script-movie"
          type="application/ld+json"
          defer={true}
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(postData?.additionalSchemas?.[0]),
          }}
  ></script>}
      {router.asPath.includes("/factcheck/") &&
        postData?.itemReviewed !== "" && (
          <script
            id="my-script2"
            type="application/ld+json"
            defer = {true}
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "ClaimReview",
                url: `${postData?.permalink}`,
                claimReviewed: `${postData?.claimReviewed}`,
                itemReviewed: {
                  "@type": "Claim",
                  author: {
                    "@type": "Organization",
                    name: `${postData?.claimMakerName}`,
                    sameAs: `${postData?.itemReviewed}`,
                  },
                  datePublished: `${postData?.claimDatePublished.slice(0, 10)}`,
                  appearance: {
                    "@type": "OpinionNewsArticle",
                    url: `${postData?.permalink}`,
                    headline: `${postData?.title}`,
                    datePublished: `${postData?.publishedAtIST}`,
                    author: {
                      "@type": "Person",
                      name: `${postData?.createdByName}`,
                    },
                    image: `${postData?.headingImageUrl}`,
                    publisher: {
                      "@type": "Organization",
                      name: "The Lallantop",
                      logo: {
                        "@type": "ImageObject",
                        url: "https://static.thelallantop.com/images/post/1695637095493_lallantop-logo_(1).webp",
                      },
                    },
                  },
                },
                author: {
                  "@type": "Organization",
                  name: "The Lallantop",
                },
                reviewRating: {
                  "@type": "Rating",
                  ratingValue: `${postData?.ratingValue}`,
                  bestRating: "5",
                  worstRating: "1",
                  alternateName: `${postData?.ratingAlternateName}`,
                },
              }),
            }}
          ></script>
        )}
    </div>
  );
};
export default NewsDetailUpdated;
